/* ============================================================
   ManMade Precision Trimmer — PDP JavaScript
   No external dependencies. Vanilla JS only.
   ============================================================ */

'use strict';

/* ----------------------------------------------------------
   1. COUNTDOWN
   ---------------------------------------------------------- */
function initCountdown() {
  document.querySelectorAll('[data-mm-countdown]').forEach(function(el) {
    var total = parseInt(el.dataset.minutes, 10) * 60;
    var remaining = total;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;
      el.textContent = '00 : ' + pad(h) + ' : ' + pad(m) + ' : ' + pad(s);
      remaining = remaining <= 0 ? total : remaining - 1;
    }

    tick();
    setInterval(tick, 1000);
  });
}

/* ----------------------------------------------------------
   3. MINI REVIEWS CAROUSEL
   ---------------------------------------------------------- */
function initMiniReviews() {
  document.querySelectorAll('[data-mm-mini-reviews]').forEach(function(container) {
    var reviews = Array.from(container.querySelectorAll('[data-review]'));
    if (reviews.length < 2) return;

    var idx = 0;

    function show(next) {
      reviews[idx].hidden = true;
      idx = (next + reviews.length) % reviews.length;
      reviews[idx].hidden = false;
    }

    var prevBtn = container.querySelector('[data-mm-mini-review-prev]');
    var nextBtn = container.querySelector('[data-mm-mini-review-next]');
    if (prevBtn) prevBtn.addEventListener('click', function() { show(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { show(idx + 1); });
  });
}

/* ----------------------------------------------------------
   4. FAQ — exclusive one-open-at-a-time
   ---------------------------------------------------------- */
function initFaq() {
  document.querySelectorAll('[data-mm-faq-exclusive]').forEach(function(list) {
    var allDetails = Array.from(list.querySelectorAll('details'));
    allDetails.forEach(function(detail) {
      detail.addEventListener('toggle', function() {
        if (detail.open) {
          allDetails.forEach(function(other) {
            if (other !== detail && other.open) other.removeAttribute('open');
          });
        }
      });
    });
  });
}

/* ----------------------------------------------------------
   5. STICKY ATC
   ---------------------------------------------------------- */
function initStickyAtc() {
  var stickyBar = document.getElementById('mm-sticky-atc');
  if (!stickyBar) return;

  // Always-on mode (theme setting sticky_trigger = 'always'): the bar is
  // rendered with data-visible from Liquid — no scroll observer needed.
  if (stickyBar.getAttribute('data-mm-trigger') === 'always') {
    stickyBar.setAttribute('data-visible', '');
    stickyBar.setAttribute('aria-hidden', 'false');
    mmSyncWidgetLift();
    return;
  }

  var hero = document.getElementById('mm-hero');
  if (!hero) return;
  // Anchor to the buybox ATC button so the bar appears as soon as the real
  // button is scrolled past; fall back to the whole hero if a template has
  // no atc block.
  var anchor = hero.querySelector('.mm-buybox__atc') || hero;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      // Only "scrolled past" (anchor above the viewport) shows the bar —
      // an anchor still below the fold on load keeps it hidden.
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        stickyBar.setAttribute('data-visible', '');
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.removeAttribute('data-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
      mmSyncWidgetLift();
    });
  }, { threshold: 0.05 });

  observer.observe(anchor);
}

/* ----------------------------------------------------------
   5a. FLOATING WIDGET LIFT
   The Klaviyo form teaser and the Gorgias chat button are fixed to the
   bottom of the viewport and overlap the sticky ATC bar. While the bar
   is visible AND actually displayed at this viewport (offsetHeight > 0
   — it is display:none on desktop) and bottom-positioned, lift them by
   the bar's height via !important margin-bottom (for fixed elements,
   `bottom` measures to the margin edge, so extra bottom margin raises
   them WITHOUT touching their own transforms — Klaviyo centers its
   teaser with translateX(-50%), so transform must stay theirs).
   Restore the original margin when the bar hides. Both widgets inject
   their DOM late, so a debounced MutationObserver re-applies the lift.
   ---------------------------------------------------------- */
var WIDGET_LIFT_SELECTOR = [
  '#gorgias-chat-container iframe#chat-button',
  '#gorgias-chat-container iframe#chat-campaigns',
  '[id^="kl-teaser"]',
  'div[class*="kl-teaser"]',
  'button[class*="kl-teaser"]',
  '.klaviyo-teaser'
].join(', ');

function mmSyncWidgetLift() {
  try {
    var bar = document.getElementById('mm-sticky-atc');
    var barH = 0;
    if (bar && bar.hasAttribute('data-visible') && bar.offsetHeight > 0 &&
        bar.className.indexOf('mm-sticky-atc--pos-top') === -1) {
      barH = bar.offsetHeight;
    }
    var changed = false;
    var els = document.querySelectorAll(WIDGET_LIFT_SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      try {
        // Skip nested matches (e.g. a kl-teaser button inside a kl-teaser
        // wrapper) — lifting both would double the offset.
        if (el.parentElement && el.parentElement.closest &&
            el.parentElement.closest(WIDGET_LIFT_SELECTOR)) continue;
        var isGorgias = el.id === 'chat-button' || el.id === 'chat-campaigns';
        if (barH > 0) {
          var wasLifted = el.hasAttribute('data-mm-lifted');
          if (!wasLifted) {
            el.setAttribute('data-mm-lifted', el.style.marginBottom || '');
            if (!isGorgias) {
              // Measured while unlifted: the teaser's natural gap to the
              // viewport bottom. Lifting by (barH - gap) lands its bottom
              // edge flush on the bar's top edge — no see-through strip.
              var gap = Math.max(0, window.innerHeight - el.getBoundingClientRect().bottom);
              el.setAttribute('data-mm-gapbase', Math.round(gap));
            }
          }
          var m;
          if (isGorgias) {
            m = barH + 8; // floating bubble keeps a little air
          } else {
            m = Math.max(0, barH - (parseFloat(el.getAttribute('data-mm-gapbase')) || 0));
            // Closed-loop correction: the initial measurement can catch the
            // teaser mid-animation (its slide-in, or our restore still in
            // flight) and land it overlapping the bar. Once our transition
            // has settled, compare where its bottom edge REALLY is to the
            // bar's top edge and nudge by the difference.
            var ts = parseFloat(el.getAttribute('data-mm-liftts')) || 0;
            if (wasLifted && Date.now() - ts > 350) {
              var cur = parseFloat(el.style.marginBottom) || 0;
              var delta = Math.round(el.getBoundingClientRect().bottom - (window.innerHeight - barH));
              m = Math.abs(delta) > 1 ? Math.max(0, cur + delta) : cur;
            }
          }
          var mStr = m + 'px';
          if (el.style.marginBottom !== mStr) {
            el.style.setProperty('transition', 'margin-bottom .25s ease', 'important');
            el.style.setProperty('margin-bottom', mStr, 'important');
            el.setAttribute('data-mm-liftts', Date.now());
            changed = true;
          }
        } else if (el.hasAttribute('data-mm-lifted')) {
          var prev = el.getAttribute('data-mm-lifted');
          el.removeAttribute('data-mm-lifted');
          el.removeAttribute('data-mm-gapbase');
          el.removeAttribute('data-mm-liftts');
          if (prev) { el.style.setProperty('margin-bottom', prev); }
          else { el.style.removeProperty('margin-bottom'); }
        }
      } catch (e) { /* one bad element must not stop the rest */ }
    }
    // A margin just changed → schedule one settle-pass after the transition
    // so the closed-loop correction always gets its post-animation look.
    if (changed) {
      clearTimeout(mmSyncWidgetLift.__t);
      mmSyncWidgetLift.__t = setTimeout(mmSyncWidgetLift, 400);
    }
  } catch (e) { /* widget lift must never break the page */ }
}

/* ----------------------------------------------------------
   5b. FLOATING WIDGET LAYERING
   Klaviyo and Gorgias pin their UI at the maximum z-index
   (2147483647), so the nav/cart drawers can never out-stack them —
   at equal z the later DOM node (the widgets, appended to body-end)
   wins. Inverse approach: while a drawer is open, demote the widgets
   below the drawer scrim with !important inline z-index and restore
   their original z-index on close. Covers the teaser AND full Klaviyo
   popups (kl-private-reset-css wrappers) plus the Gorgias iframes.
   ---------------------------------------------------------- */
var WIDGET_LAYER_SELECTOR = [
  '#gorgias-chat-container iframe#chat-button',
  '#gorgias-chat-container iframe#chat-campaigns',
  '#gorgias-chat-container iframe#chat-window',
  '[id^="kl-teaser"]',
  'div[class*="kl-teaser"]',
  'button[class*="kl-teaser"]',
  '.klaviyo-teaser',
  'div[class*="kl-private-reset-css"]'
].join(', ');

function mmSyncWidgetLayer() {
  try {
    var navDrawer = document.getElementById('mm-drawer');
    var cartDrawer = document.getElementById('mm-cart');
    var covered = (navDrawer && navDrawer.hasAttribute('data-open')) ||
                  (cartDrawer && cartDrawer.hasAttribute('data-open'));
    var els = document.querySelectorAll(WIDGET_LAYER_SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      try {
        if (covered) {
          if (!el.hasAttribute('data-mm-layered')) {
            el.setAttribute('data-mm-layered', el.style.zIndex || '');
          }
          // Below the drawer scrim (60) and drawers (70+), above page chrome.
          el.style.setProperty('z-index', '49', 'important');
        } else if (el.hasAttribute('data-mm-layered')) {
          var prev = el.getAttribute('data-mm-layered');
          el.removeAttribute('data-mm-layered');
          if (prev) { el.style.setProperty('z-index', prev); }
          else { el.style.removeProperty('z-index'); }
        }
      } catch (e) { /* one bad element must not stop the rest */ }
    }
  } catch (e) { /* layering must never break the page */ }
}

function initWidgetLift() {
  var t;
  var syncAll = function() { mmSyncWidgetLift(); mmSyncWidgetLayer(); mmApplyDiscountLabels(); };
  var debounced = function() { clearTimeout(t); t = setTimeout(syncAll, 200); };
  try {
    new MutationObserver(debounced).observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* no observer → IO callback + resize still cover it */ }
  window.addEventListener('resize', debounced);
  // Drawer open/close must re-layer instantly, not on the debounce.
  ['mm-drawer', 'mm-cart'].forEach(function(id) {
    var d = document.getElementById(id);
    if (!d) return;
    try {
      new MutationObserver(mmSyncWidgetLayer).observe(d, { attributes: true, attributeFilter: ['data-open'] });
    } catch (e) { /* debounced body observer still covers it */ }
  });
  syncAll();
}

/* ----------------------------------------------------------
   5b. STICKY ATC LABEL — Kaching discount pass
   The Liquid snippet substitutes {discountp|discountpr|discount$|discount$r}
   from variant compare-at prices / hero overrides. Kaching Bundles deals
   (specific-price or percentage tiers) apply at cart via a discount
   function and are invisible to Liquid — but the app server-renders its
   deal config as JSON into the page. When the preselected deal bar
   carries a real discount, recompute the label from it here; otherwise
   the server-rendered label (compare-at based, or the fallback) stays.
   ---------------------------------------------------------- */
// Parity with Liquid money_without_trailing_zeros: "$80" / "$80.01"
function mmDiscountMoney(cents) {
  var v = cents / 100;
  return '$' + (cents % 100 === 0 ? v : v.toFixed(2));
}

/* Resolve the page's Kaching Bundles deal (preselected bar) into cents.
   Returns { save, orig } or null when there is no real Kaching discount.

   Anchor: when the block is set to "use product compare-at price" (the
   widget strikes the compare-at, and so does the buybox), the saving is
   measured from the compare-at price so every figure on the page agrees.
   Otherwise it's measured from the variant price. A "default" deal bar
   carries no discount at all and yields null.

   A/B tests: Kaching server-renders one config script PER TEST VARIANT
   (all with the same data-product-id) and picks the shopper's bucket at
   runtime. Best effort here (mmKachingPickConfig): prefer the config whose
   ids appear in the rendered widget's markup; otherwise the first one —
   which can disagree with what the shopper sees. That is why the {discount}
   source defaults to compare-at (Theme settings → Kaching widgets) and this
   path is opt-in. */
function mmKachingDeal() {
  try {
    var prodEl = document.querySelector('.kaching-bundles-product[data-main="true"]') ||
                 document.querySelector('.kaching-bundles-product');
    if (!prodEl) return null;
    var pid = prodEl.getAttribute('data-product-id');
    var dealEls = document.querySelectorAll('.kaching-bundles-deal-block-settings[data-product-id="' + pid + '"]');
    if (!dealEls.length) dealEls = document.querySelectorAll('.kaching-bundles-deal-block-settings');
    if (!dealEls.length) return null;

    var prod = JSON.parse(prodEl.textContent);
    var cfg = mmKachingPickConfig(dealEls);
    if (!cfg) return null;
    var bars = cfg.dealBars || [];
    var deal = null;
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].id === cfg.preselectedDealBarId) { deal = bars[i]; break; }
    }
    deal = deal || bars[0];
    if (!deal || deal.discountType === 'default') return null;

    // Unit + compare-at in cents from Kaching's own product JSON
    var v = null;
    var variants = prod.variants || [];
    for (var j = 0; j < variants.length; j++) {
      if (variants[j].id === prod.selectedVariantId) { v = variants[j]; break; }
    }
    if (!v && variants.length) v = variants[0];
    if (!v || !v.price) return null;
    var unit = v.price;
    var compare = (typeof v.compareAtPrice === 'number' && v.compareAtPrice > unit) ? v.compareAtPrice : 0;
    var anchor = (cfg.useProductCompareAtPrice && compare) ? compare : unit;

    var qty = deal.quantity || 1;
    var pay = unit * qty; // what the shopper pays after the deal
    if (deal.discountType === 'specific') {
      pay = Math.round(deal.discountValue * 100); // discountValue = deal price in dollars
    } else if (deal.discountType === 'percentage') {
      pay = Math.round(unit * qty * (1 - deal.discountValue / 100));
    } else if (deal.discountType === 'amount' || deal.discountType === 'fixed') {
      pay = unit * qty - Math.round(deal.discountValue * 100);
    }
    var orig = anchor * qty;
    var save = orig - pay;
    if (save <= 0 || save >= orig) return null;
    return { save: save, orig: orig };
  } catch (e) { return null; }
}

// Prefer the A/B config the widget actually rendered (its ids show up in
// the block's markup); fall back to the first script.
function mmKachingPickConfig(dealEls) {
  var cfgs = [];
  for (var i = 0; i < dealEls.length; i++) {
    try { cfgs.push(JSON.parse(dealEls[i].textContent)); } catch (e) { /* skip a bad one */ }
  }
  if (!cfgs.length) return null;
  if (cfgs.length > 1) {
    var block = document.querySelector('kaching-bundle, kaching-bundles-block');
    var html = block ? block.outerHTML : '';
    if (html) {
      for (var k = 0; k < cfgs.length; k++) {
        var c = cfgs[k];
        var keys = [c.abTestVariantId, c.versionId, c.nanoId].filter(Boolean);
        for (var m = 0; m < keys.length; m++) {
          if (html.indexOf(keys[m]) > -1) return c;
        }
      }
    }
  }
  return cfgs[0];
}

/* ----------------------------------------------------------
   KACHING SWATCHES → THEME (mm:variant:change)
   Kaching renders its own variant picker (swatches / pills / comboboxes)
   and fires no variant event, so watch its block and re-read the selection
   whenever the subtree changes. Each swatch button carries data-value /
   title = the option value and the active one has a --selected class;
   combobox selects show the value as text. Values → variant through
   Kaching's own product JSON (options in option order).

   The first successful read only primes lastId — nothing on the page should
   react to the default variant — and every later change raises
   mm:variant:change {id, options, image, source:'kaching'}. The theme's own
   picker (initVariantPickers) raises the same event, so listeners (the hero
   gallery's slide-1 swap) don't care where the pick came from.
   ---------------------------------------------------------- */
function initKachingVariantSync() {
  var host = document.querySelector('kaching-bundle, kaching-bundles-block');
  if (!host || typeof MutationObserver === 'undefined') return;
  var variants = null;
  var lastId = null;
  var primed = false;

  // "Selected: Purple" under the swatches (design C; Theme settings → Kaching
  // widgets). Lives OUTSIDE Kaching's element, as its next sibling, so the
  // widget's re-renders never wipe it. Filled on every read, the priming one
  // included — the shopper should see the default pick too.
  var body = document.body;
  var wantText = !!(body && body.classList.contains('mm-kw-c') && body.hasAttribute('data-mm-kw-selected'));
  var textEl = null;
  function showSelected(vals) {
    if (!wantText) return;
    if (!textEl || !textEl.isConnected) {
      textEl = document.createElement('p');
      textEl.className = 'mm-kw-selected';
      textEl.setAttribute('aria-live', 'polite');
      var prefix = body.getAttribute('data-mm-kw-selected') || '';
      textEl.innerHTML = (prefix ? '<span class="mm-kw-selected__label">' + escapeHtml(prefix) + '</span> ' : '') +
        '<b class="mm-kw-selected__value"></b>';
      host.insertAdjacentElement('afterend', textEl);
    }
    var valueEl = textEl.querySelector('.mm-kw-selected__value');
    var txt = vals.join(' · ');
    if (valueEl && valueEl.textContent !== txt) valueEl.textContent = txt;
  }

  function kachingVariants() {
    try {
      var el = document.querySelector('.kaching-bundles-product[data-main="true"]') ||
               document.querySelector('.kaching-bundles-product');
      return el ? (JSON.parse(el.textContent).variants || []) : [];
    } catch (e) { return []; }
  }

  // Kaching's "require variant selection" leaves the swatches unpicked until
  // the shopper taps one. With data-mm-kw-preselect on <body> (Theme settings
  // → Kaching widgets), pick the page's current variant for them — the URL's
  // ?variant= if present (the form's hidden id input already reflects it),
  // else the first available — by clicking its swatch exactly as a shopper
  // would, so Kaching's own state follows. Once only, and only while nothing
  // is selected; the resulting read primes silently, so no gallery swap.
  var wantPreselect = !!(body && body.hasAttribute('data-mm-kw-preselect'));
  var preselected = false;
  function preselect() {
    if (!wantPreselect || preselected) return;
    var bar = host.querySelector('.kaching-bundles__bar--selected') || host.querySelector('.kaching-bundles__bar');
    if (!bar) return;
    var scope = bar.querySelector('.kaching-bundles__bar-variant') || bar;
    var groups = scope.querySelectorAll('.kaching-bundles__swatch-buttons, .kaching-bundles__pill-buttons');
    if (!groups.length || scope.querySelector('[class*="__button--selected"]')) return;
    if (!variants || !variants.length) variants = kachingVariants();
    if (!variants.length) return;
    var idInput = document.querySelector('[data-mm-product-form] [data-mm-variant-id], [data-mm-variant-id]');
    var wantId = idInput ? parseInt(idInput.value, 10) : 0;
    var target = null;
    for (var i = 0; i < variants.length && !target; i++) if (variants[i].id === wantId) target = variants[i];
    for (var j = 0; j < variants.length && !target; j++) if (variants[j].availableForSale !== false) target = variants[j];
    target = target || variants[0];
    var opts = target.options || [];
    preselected = true;
    groups.forEach(function (g, k) {
      var val = opts[k];
      var btn = val != null ? g.querySelector('[data-value="' + String(val).replace(/"/g, '\\"') + '"]') : null;
      if (!btn) btn = g.querySelector('[data-value]');
      if (btn) btn.click();
    });
  }

  function selectedValues() {
    var bar = host.querySelector('.kaching-bundles__bar--selected') || host.querySelector('.kaching-bundles__bar') || host;
    var scope = bar.querySelector('.kaching-bundles__bar-variant') || bar.querySelector('.kaching-bundles__bar-variants') || bar;
    var vals = [];
    scope.querySelectorAll('.kaching-bundles__swatch-buttons, .kaching-bundles__pill-buttons').forEach(function (g) {
      var b = g.querySelector('[class*="__button--selected"]');
      var v = b && (b.getAttribute('data-value') || b.getAttribute('title'));
      if (v) vals.push(v.trim());
    });
    if (!vals.length) {
      scope.querySelectorAll('.kaching-bundles__bar-variant-select').forEach(function (el) {
        var v = el.textContent.trim();
        if (v) vals.push(v);
      });
    }
    if (!vals.length) {
      scope.querySelectorAll('.kaching-bundles__bar-variant-option__name-value').forEach(function (el) {
        var v = el.textContent.trim();
        if (v) vals.push(v);
      });
    }
    return vals.length ? vals : null;
  }

  function sync() {
    var vals = selectedValues();
    if (!vals) { preselect(); return; }
    showSelected(vals);
    if (!variants || !variants.length) variants = kachingVariants();
    var match = null;
    for (var i = 0; i < variants.length && !match; i++) {
      var o = variants[i].options || [];
      if (o.length === vals.length && o.every(function (x, k) { return x === vals[k]; })) match = variants[i];
    }
    // Layouts that only show some options: every shown value must belong to the variant.
    for (var j = 0; j < variants.length && !match; j++) {
      var oo = variants[j].options || [];
      if (vals.every(function (v) { return oo.indexOf(v) > -1; })) match = variants[j];
    }
    if (!match || match.id === lastId) return;
    lastId = match.id;
    if (!primed) { primed = true; return; }
    document.dispatchEvent(new CustomEvent('mm:variant:change', {
      detail: { id: match.id, options: match.options || vals, image: match.image || null, source: 'kaching' }
    }));
  }

  var raf = 0;
  var mo = new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; sync(); });
  });
  mo.observe(host, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'], characterData: true });
  sync();
}

function mmSubstDiscount(tpl, save, orig) {
  var pct = save * 100 / orig;
  var pct1 = Math.round(pct * 10) / 10;
  var pctInt = Math.round(pct);
  return tpl
    .split('{discount$r}').join(mmDiscountMoney(Math.round(save / 100) * 100))
    .split('{discount$}').join(mmDiscountMoney(save))
    .split('{discountpr}').join(pctInt + '%')
    .split('{discountp}').join((pct1 === pctInt ? pctInt : pct1) + '%');
}

/* Apply the Kaching discount to every label that carries a raw template:
   the sticky ATC bar (data-mm-label-template) and any text rendered
   through snippets/mm-discount-label.liquid (data-mm-discount-text —
   all pdp-button labels flow through it when they contain a token).
   Server-side Liquid already substituted compare-at based values; this
   pass only overwrites when a real Kaching deal exists. Writes are
   equality-guarded so the body MutationObserver never self-triggers. */
function mmApplyDiscountLabels() {
  try {
    // Theme settings → Kaching widgets → "{discount} tokens are measured from".
    // compare_at (default): the server-rendered, compare-at based labels stand
    // and this pass does nothing. kaching: recompute from the live deal. No
    // attribute at all (older layouts) keeps the historical Kaching behavior.
    var src = document.body ? document.body.getAttribute('data-mm-discount-source') : null;
    if (src && src !== 'kaching') return;
    var deal = mmKachingDeal();
    if (!deal) return;

    var bar = document.getElementById('mm-sticky-atc');
    if (bar) {
      var tpl = bar.getAttribute('data-mm-label-template');
      var labelEl = bar.querySelector('.mm-btn__label');
      if (tpl && tpl.indexOf('{discount') > -1 && labelEl) {
        var out = mmSubstDiscount(tpl, deal.save, deal.orig);
        if (bar.hasAttribute('data-mm-label-append-price')) out += ' — ' + mmDiscountMoney(deal.orig - deal.save);
        if (labelEl.textContent !== out) labelEl.textContent = out;
      }
    }

    document.querySelectorAll('[data-mm-discount-text]').forEach(function (el) {
      try {
        var raw = el.getAttribute('data-mm-discount-text');
        if (!raw || raw.indexOf('{discount') === -1) return;
        var txt = mmSubstDiscount(raw, deal.save, deal.orig);
        if (el.textContent !== txt) el.textContent = txt;
      } catch (e) { /* one bad label must not stop the rest */ }
    });
  } catch (e) { /* label enhancement must never break the page */ }
}

function initStickyLabelDiscount() {
  mmApplyDiscountLabels();
}

/* ----------------------------------------------------------
   6. CART STATE
   ---------------------------------------------------------- */
// /cart.js does not reliably populate `compare_at_price` on line items
// (Markets currency, B2B, and bundle apps like Kaching often strip it).
// We hydrate it ourselves from /products/{handle}.js, keyed by variant id.
var variantComparePriceCache = {};
// One-time variant price, keyed by variant id. Subscription line items compare
// against this (the price you'd pay without the plan) so the cart's savings
// mirror the on-PDP "Subscribe & Protect" offer, not the retail compare-at.
var variantPriceCache = {};
// First available subscription offer per variant id: { planId, price } in
// cents, from the same /products/{handle}.js fetch. Powers the cart drawer's
// "Subscribe & Save" toggle on lines the shopper added as one-time.
var variantSubPlanCache = {};
// True when the variant's product is only sold on a plan (no one-time option):
// the cart pill never offers one-time there.
var variantRequiresPlanCache = {};
// Product tags keyed by handle — feeds the tag-targeted add-on cards
// (data-mm-addon-tag). Filled by the same /products/{handle}.js fetch
// that hydrates compare-at prices, so no extra requests.
var productTagsCache = {};
var productFetchInFlight = {};

// The allocation the cart offers for "Subscribe & Save": the site-wide offer
// plan (Theme settings → Subscription offer, data-offer-plans on #mm-cart;
// same rule as snippets/mm-offer-plan.liquid) when the variant has it, else
// the first plan.
function mmOfferAlloc(allocs) {
  if (!Array.isArray(allocs) || !allocs.length) return null;
  var cart = document.getElementById('mm-cart');
  var ids = String((cart && cart.getAttribute('data-offer-plans')) || '').split(/[\s,]+/);
  for (var i = 0; i < ids.length; i++) {
    var id = ids[i].split('/').pop();
    if (!id) continue;
    for (var j = 0; j < allocs.length; j++) {
      if (String(allocs[j].selling_plan_id) === id) return allocs[j];
    }
  }
  return allocs[0];
}

function hydrateVariantComparePrices(items) {
  var handles = {};
  items.forEach(function(it) {
    if (!it.handle) return;
    if (variantComparePriceCache[it.variant_id] !== undefined) return;
    handles[it.handle] = true;
  });
  var pending = Object.keys(handles).map(function(handle) {
    if (productFetchInFlight[handle]) return productFetchInFlight[handle];
    productFetchInFlight[handle] = fetch('/products/' + handle + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) {
        if (!p) return;
        if (Array.isArray(p.tags)) productTagsCache[handle] = p.tags;
        if (!Array.isArray(p.variants)) return;
        p.variants.forEach(function(v) {
          var cap = (typeof v.compare_at_price === 'number') ? v.compare_at_price : null;
          variantComparePriceCache[v.id] = (cap && cap > v.price) ? cap : null;
          if (typeof v.price === 'number') variantPriceCache[v.id] = v.price;
          variantRequiresPlanCache[v.id] = !!p.requires_selling_plan;
          var subAlloc = mmOfferAlloc(v.selling_plan_allocations);
          variantSubPlanCache[v.id] = (subAlloc && typeof subAlloc.price === 'number' && subAlloc.selling_plan_id)
            ? { planId: subAlloc.selling_plan_id, price: subAlloc.price }
            : null;
        });
      })
      .catch(function() {});
    return productFetchInFlight[handle];
  });
  return Promise.all(pending);
}

/* Tag-targeted add-on cards: the drawer server-renders them hidden with
   data-mm-addon-tag (see pdp-cart-addon-card.liquid). Reveal one only while
   some cart line's product carries that tag. Tag matching is case-insensitive.
   A card stays hidden when its product is already a cart line (nothing to
   upsell) or when a visible merchant-picked card already shows the same
   product (no duplicates). Runs after hydrateVariantComparePrices so
   productTagsCache is populated. */
function updateTagUpsells(items) {
  var cards = document.querySelectorAll('.mm-cart__addon[data-mm-addon-tag]');
  if (!cards.length) return;
  var tagsInCart = {};
  var handlesInCart = {};
  items.forEach(function(it) {
    if (!it.handle) return;
    handlesInCart[it.handle] = true;
    (productTagsCache[it.handle] || []).forEach(function(t) {
      tagsInCart[String(t).trim().toLowerCase()] = true;
    });
  });
  cards.forEach(function(card) {
    var tag = (card.getAttribute('data-mm-addon-tag') || '').trim().toLowerCase();
    var show = !!tag && !!tagsInCart[tag];
    if (show) {
      var url = card.getAttribute('data-url') || '';
      var handle = url.split('?')[0].split('/').pop();
      if (handle && handlesInCart[handle]) show = false;
    }
    if (show) {
      var staticCards = document.querySelectorAll('.mm-cart__addon:not([data-mm-addon-tag])');
      for (var i = 0; i < staticCards.length; i++) {
        if (staticCards[i].getAttribute('data-url') === url) { show = false; break; }
      }
    }
    card.hidden = !show;
  });
  syncAddonsShelf();
}

/* The add-ons shelf never leaves the drawer. The theme card frame shows
   whenever any card inside it is visible — empty cart included (the shelf
   sits under the empty-state CTA and gives the shopper something to add) —
   and only hides when literally nothing is left to show (a drawer configured
   with ONLY tag-targeted cards and no tag match). Also flags the items list
   while the empty message shares it with a live shelf so the message stops
   filling the full height and the shelf lands in view instead of below the
   fold. Every path that can change what's on the shelf (renderItems,
   updateTagUpsells) calls this; nothing else writes the frame's hidden
   attribute. */
function syncAddonsShelf() {
  var wrap = document.querySelector('[data-mm-addons]');
  if (wrap) wrap.hidden = !wrap.querySelector('.mm-cart__addon:not([hidden])');
  var container = document.getElementById('mm-cart-items');
  if (!container) return;
  var empty = document.getElementById('mm-cart-empty');
  var isEmpty = !!(empty && !empty.hidden);
  var ownUp = !!(wrap && !wrap.hidden);
  container.classList.toggle('mm-cart__items--empty-shelf', isEmpty && ownUp);
}

function getItemComparePrice(item) {
  if (typeof item.compare_at_price === 'number' && item.compare_at_price > item.price) {
    return item.compare_at_price;
  }
  var cached = variantComparePriceCache[item.variant_id];
  return (typeof cached === 'number' && cached > item.price) ? cached : null;
}

// The subscription offer for a one-time line's own variant, if any.
function getItemSubPlanOffer(item) {
  return variantSubPlanCache[item.variant_id] || null;
}

var CartState = {
  items: [],
  subtotal: 0,

  async fetch() {
    try {
      var res = await fetch('/cart.js');
      if (!res.ok) return;
      var data = await res.json();
      this.items = data.items || [];
      this.subtotal = data.total_price || 0;
      this.loaded = true; // an empty `items` is only "empty cart" once this is set (pdp-mm15 add-to-cart verification)
      this.updateBadge();
      this.renderItems();
      this.updateShippingBar();
      this.updateGiftBar();
      GiftReward.update();
      // Notify any listeners (sticky ATC, external apps, analytics).
      document.dispatchEvent(new CustomEvent('mm:cart:updated', { detail: data }));
      // Hydrate compare-at prices in the background, then re-render so
      // the savings strikethrough / "Save $X" badge appears once the
      // variant data arrives. First render is unblocked.
      var self = this;
      hydrateVariantComparePrices(this.items).then(function() {
        updateTagUpsells(self.items);
        self.renderItems();
      });
    } catch (e) {
      /* silent */
    }
  },

  // An empty cart shows no progress rows — "You're $25 away" with nothing in
  // the cart reads as noise. Editor-pinned drawers keep them up so the rows
  // stay styleable against the editor's usually-empty preview cart.
  emptyAndNotPinned() {
    if (this.items.length > 0) return false;
    var drawerEl = document.getElementById('mm-cart');
    return !(drawerEl && drawerEl.hasAttribute('data-editor-pinned'));
  },

  updateShippingBar() {
    var bar = document.getElementById('mm-cart-ship');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10) || 0;
    if (!threshold || this.emptyAndNotPinned()) { bar.hidden = true; return; }
    var remaining = Math.max(0, threshold - this.subtotal);
    var pct = Math.min(100, (this.subtotal / threshold) * 100);
    var fill = bar.querySelector('[data-mm-ship-fill]');
    var msg  = bar.querySelector('[data-mm-ship-msg]');
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      // Templates are merchant-defined in PDP Header settings.
      // {amount} is replaced with the formatted remaining $.
      var tplProgress = bar.dataset.textProgress || 'You’re {amount} away from free shipping';
      var tplUnlocked = bar.dataset.textUnlocked || '🎉 You unlocked <strong>free shipping</strong>!';
      var amount = '<strong>' + formatMoney(remaining) + '</strong>';
      msg.innerHTML = remaining === 0
        ? tplUnlocked
        : tplProgress.replace(/\{amount\}/g, amount);
    }
    if (remaining === 0) bar.setAttribute('data-unlocked', '');
    else bar.removeAttribute('data-unlocked');
    bar.hidden = false;
  },

  updateGiftBar() {
    var bar = document.getElementById('mm-cart-gift');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10) || 0;
    if (!threshold || this.emptyAndNotPinned()) { bar.hidden = true; return; }
    mmGiftBarPaint(bar, this.subtotal);
    bar.hidden = false;
  },

  // Lines the shopper actually pays for — feeds the badge / item count only.
  // Kaching bundle components discounted to $0 DO display in the drawer
  // (nested under their anchor line via buildCartRows), but they're owned by
  // the bundle, so they don't inflate the count the shopper sees.
  // Fail-open: if somehow every line is $0 (e.g. an orphaned gift), count
  // everything rather than showing an empty badge on a cart that checks out.
  paidItems() {
    var paid = this.items.filter(function (it) {
      var line = (typeof it.final_line_price === 'number') ? it.final_line_price
        : (typeof it.line_price === 'number') ? it.line_price
        : it.price * it.quantity;
      return line > 0;
    });
    return paid.length ? paid : this.items;
  },

  updateBadge() {
    var count = this.paidItems().reduce(function(sum, item) { return sum + item.quantity; }, 0);
    document.querySelectorAll('[data-mm-cart-count]').forEach(function(el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    // Keep the cart-page "Your Cart (N items)" heading in sync when the
    // drawer's own qty controls are the source of truth — e.g. user is
    // sitting on /cart and adjusts qty inside the drawer. Subtotal/total
    // on the cart page are intentionally left to its own handler so
    // discount semantics stay correct.
    document.querySelectorAll('[data-mm-cart-item-count]').forEach(function(el) { el.textContent = count; });
    // Drawer heading "CART • n" — hide the bullet + count on an empty cart.
    document.querySelectorAll('[data-mm-cart-count-wrap]').forEach(function(el) { el.hidden = count === 0; });
    document.querySelectorAll('[data-mm-cart-item-word]').forEach(function(el) {
      el.textContent = count === 1 ? 'item' : 'items';
    });
    // Toggle the cart-icon animation when items are present.
    document.querySelectorAll('.mm-nav__icon--cart[data-mm-cart-anim]').forEach(function(btn) {
      if (count > 0) btn.classList.add('mm-cart-anim--active');
      else btn.classList.remove('mm-cart-anim--active');
    });
  },

  renderItems() {
    var container = document.getElementById('mm-cart-items');
    var footer = document.getElementById('mm-cart-footer');
    var empty = document.getElementById('mm-cart-empty');
    var reserve = document.querySelector('[data-mm-reserve]');
    var subtotalEl = document.getElementById('mm-cart-subtotal');
    var drawerEl = document.getElementById('mm-cart');
    if (!container) return;

    // "Pin drawer open" in the theme editor: every Apply re-renders the section
    // and refetches /cart.js, and the editor's preview cart is usually empty —
    // which would hide the footer and countdown, i.e. exactly the chrome being
    // styled. While pinned, keep them up. data-editor-pinned only renders when
    // request.design_mode is true, so this can never affect a real shopper.
    var editorPinned = !!(drawerEl && drawerEl.hasAttribute('data-editor-pinned'));

    if (this.items.length === 0) {
      // Drop any leftover line rows before showing the empty state — the
      // container holds #mm-cart-empty alongside the dynamic .mm-cart__item
      // rows, and removing the last item otherwise leaves the (dimmed,
      // optimistically-patched) row sitting behind the empty message.
      container.querySelectorAll('.mm-cart__item').forEach(function(el) { el.remove(); });
      // An in-flight ATC keeps its stand-in up even over an empty server
      // cart — insertPendingLine re-hides the empty state and re-shows the
      // footer itself.
      if (mmReassertPendingSetup(container)) return;
      if (empty) empty.hidden = false;
      // Keep the footer up while an error is showing — the error line lives
      // inside it, and a failed FIRST add reconciles back to an empty cart
      // (this render) right after showCartError() unhides the footer.
      var errorShowing = document.getElementById('mm-cart-error');
      errorShowing = !!(errorShowing && !errorShowing.hidden);
      if (footer) footer.hidden = !editorPinned && !errorShowing;
      if (reserve) reserve.hidden = !editorPinned;
      // The add-ons shelf stays up on an empty cart — it's the one thing
      // left to act on besides the empty-state CTA, and it must never
      // disappear from the drawer.
      syncAddonsShelf();
      if (editorPinned) {
        mmPaintCartTotal(subtotalEl, this.subtotal);
        CartReserve.start();
      } else {
        CartReserve.stop();
      }
      return;
    }

    if (empty) empty.hidden = true;
    if (footer) footer.hidden = false;
    if (reserve) reserve.hidden = false;
    syncAddonsShelf();

    var savingsMode = (drawerEl && drawerEl.dataset.savingsMode) || 'strikethrough';

    // Every line renders — free or not. Bundle components ($0 or discounted)
    // nest under their anchor row via buildCartRows(); anything ungrouped
    // keeps its own top-level row. Their value still feeds the "You save"
    // pill below via renderCartSavings(this.items).
    var html = buildCartRows(this.items).map(function(row) {
      var item = row.item;
      var isProtection = (item.properties && item.properties._protection) ? true : false;
      var isGift = !!(item.properties && item.properties[GiftReward.PROP]);
      var isSub = !isProtection && !isGift && !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
      var imgSrc = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace(/\.([^.]+)$/, '_120x120.$1')
        : '';
      var media = isProtection
        ? '<div class="mm-cart__item-img mm-cart__item-shield" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
              '<path d="M12 2.5l8 3.2v6.1c0 4.4-3.4 8.4-8 9.7-4.6-1.3-8-5.3-8-9.7V5.7l8-3.2z"/>' +
              '<path d="M9 12l2 2 4-4"/>' +
            '</svg>' +
          '</div>'
        : (imgSrc
            ? '<img class="mm-cart__item-img" src="' + imgSrc + '" alt="' + escapeHtml(item.title) + '" width="72" height="72" loading="lazy">'
            : '<div class="mm-cart__item-img mm-ph" data-label="ITEM"></div>');
      var subline;
      if (isProtection) {
        subline = '<div class="mm-cart__item-pill">Add-on · Shipping Protection</div>';
      } else if (isGift) {
        subline = '<div class="mm-cart__item-pill">Free gift</div>' +
          ((item.variant_title && item.variant_title !== 'Default Title')
            ? '<div class="mm-cart__item-variant">' + escapeHtml(item.variant_title) + '</div>'
            : '');
      } else {
        var sublineParts = '';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          sublineParts += '<div class="mm-cart__item-variant">' + escapeHtml(item.variant_title) + '</div>';
        }
        var spa = item.selling_plan_allocation;
        if (spa && spa.selling_plan && spa.selling_plan.name) {
          // Resupply lines read like the PDP offer card, not a contract: the
          // plan name ("30-Day Supply") in the accent, then the cadence
          // ("Delivered every / 30 days") taken from the plan itself. The
          // word "subscription" is avoided on purpose (user: it sounds
          // scarier). The cadence is a quieter one-liner so it doesn't
          // echo the accent plan name, and "Cancel anytime" replaces the
          // policy link on the line (user request 2026-09-30).
          var cadence = mmPlanCadenceText(spa.selling_plan);
          var planDesc = (spa.selling_plan.description && String(spa.selling_plan.description).trim())
            ? String(spa.selling_plan.description).trim()
            : '';
          sublineParts +=
            '<div class="mm-cart__item-sub">' +
              '<div class="mm-cart__item-supply">' + escapeHtml(spa.selling_plan.name) + '</div>' +
              (cadence
                ? '<div class="mm-cart__item-every">' +
                    '<span class="mm-cart__item-every-label">Delivered every</span> ' +
                    '<span class="mm-cart__item-every-val">' + escapeHtml(cadence) + '</span>' +
                  '</div>'
                : '') +
              (planDesc ? '<div class="mm-cart__item-sub-desc">' + escapeHtml(planDesc) + '</div>' : '') +
              '<div class="mm-cart__item-cancel">' +
                '<svg viewBox="0 0 16 16" width="13" height="13" fill="none" aria-hidden="true">' +
                  '<path d="M3.5 8.4l2.9 2.9 6.1-6.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
                '</svg>' +
                'Cancel anytime' +
              '</div>' +
            '</div>';
        }
        if (item.properties) {
          var propsHtml = '';
          for (var pk in item.properties) {
            if (!Object.prototype.hasOwnProperty.call(item.properties, pk)) continue;
            if (pk.charAt(0) === '_') continue;
            var pv = item.properties[pk];
            if (pv === null || pv === undefined || pv === '') continue;
            propsHtml += '<li><strong>' + escapeHtml(pk) + ':</strong> ' + escapeHtml(String(pv)) + '</li>';
          }
          if (propsHtml) {
            sublineParts += '<ul class="mm-cart__item-props" role="list">' + propsHtml + '</ul>';
          }
        }
        subline = sublineParts;
      }
      // Gifts and shipping protection have no stepper — the trash button
      // (every line) is their remove control.
      var qty = (isProtection || isGift)
        ? ''
        : '<div class="mm-cart__item-qty" role="group" aria-label="Quantity">' +
            '<button class="mm-cart__qty-btn mm-cart__qty-btn--dec" data-mm-action="cart-qty" data-key="' + item.key + '" data-delta="-1" aria-label="Remove one">−</button>' +
            '<span class="mm-cart__qty-val">' + item.quantity + '</span>' +
            '<button class="mm-cart__qty-btn mm-cart__qty-btn--inc" data-mm-action="cart-qty" data-key="' + item.key + '" data-delta="1" aria-label="Add one">+</button>' +
          '</div>';
      var trash = '<button type="button" class="mm-cart__item-trash" data-mm-action="cart-qty" data-key="' + item.key + '" data-delta="-' + item.quantity + '" aria-label="' + escapeHtml('Remove ' + (isGift ? 'free gift' : isProtection ? 'shipping protection' : item.title)) + '">' + MM_TRASH_SVG + '</button>';
      // Foot row: stepper left, savings badge + price stacked right.
      var pricing = '<div class="mm-cart__item-pricing">' +
          (isGift ? '' : renderItemSaveBadge(item, savingsMode)) +
          (isGift ? renderGiftLinePrice(item, savingsMode) : renderItemPrice(item, savingsMode)) +
        '</div>';
      return '<div class="mm-cart__item' + (isProtection ? ' mm-cart__item--protection' : '') + (isGift ? ' mm-cart__item--gift' : '') + (isSub ? ' mm-cart__item--sub' : '') + '" data-key="' + item.key + '">' +
        media +
        '<div class="mm-cart__item-meta">' +
          '<div class="mm-cart__item-name">' + escapeHtml(item.title) + '</div>' +
          subline +
          '<div class="mm-cart__item-foot">' + qty + pricing + '</div>' +
        '</div>' +
        trash +
        renderBundleGifts(row.gifts) +
        (isProtection || isGift ? '' : renderPurchasePill(item)) +
      '</div>';
    }).join('');

    var existingItems = container.querySelectorAll('.mm-cart__item');
    existingItems.forEach(function(el) { el.remove(); });
    if (empty) {
      container.insertAdjacentHTML('afterbegin', html);
    } else {
      container.innerHTML = html;
    }

    mmPaintCartTotal(subtotalEl, this.subtotal);
    renderCartSavings(this.items);
    mmReassertPendingSetup(container);
  }
};

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// Savings displays show round numbers: nearest $5 step ($84.99 → $85);
// under $5 the exact amount stays so a badge can't read $0.
function mmSaveRound(cents) {
  return cents >= 500 ? Math.round(cents / 500) * 500 : cents;
}

// Per-unit "was" price for a line item.
//   • Subscription lines compare against the ONE-TIME price (what you'd pay
//     without the plan) so the drawer matches the on-PDP subscribe offer
//     (e.g. $129.99 → $116.99). We pull that from the hydrated variant price
//     or the selling-plan allocation's compare-at. The retail compare-at is
//     only the LAST resort — for plans priced the same as one-time, where
//     the deal is baked into the variant price (Full Stack Formula: $39 plan,
//     $39 one-time, $89 retail; the PDP card shows $39 was $89). Using it
//     first would resurrect the trimmer's $160-vs-offer mismatch.
//   • One-time lines keep the existing retail compare-at behavior.
function getItemWasUnit(item) {
  var unitNow = (item.quantity > 0 && typeof item.final_line_price === 'number')
    ? item.final_line_price / item.quantity
    : item.price;
  if (item.selling_plan_allocation) {
    var spa = item.selling_plan_allocation;
    if (typeof variantPriceCache[item.variant_id] === 'number' && variantPriceCache[item.variant_id] > unitNow) {
      return variantPriceCache[item.variant_id];
    }
    if (typeof spa.compare_at_price === 'number' && spa.compare_at_price > unitNow) {
      return spa.compare_at_price;
    }
    var retail = getItemComparePrice(item) || 0;
    return retail > unitNow ? retail : 0;
  }
  return getItemComparePrice(item) || 0;
}

function computeItemSavings(item) {
  var now = item.final_line_price;
  var was = item.original_line_price && item.original_line_price > now
    ? item.original_line_price
    : null;
  if (!was) {
    var wasUnit = getItemWasUnit(item);
    if (wasUnit) was = wasUnit * item.quantity;
  }
  return { now: now, was: was };
}

// Trash glyph for the per-line remove button (renderItems).
var MM_TRASH_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
  '<path d="M4 7h16"/><path d="M9 7V4.5h6V7"/><path d="M6.5 7l1 13h9l1-13"/><path d="M10 11v6M14 11v6"/></svg>';

// Badge copy: "Save 60%" in save_percent mode, else the $5-rounded amount.
function mmSaveBadgeText(saved, was, mode) {
  if (mode === 'save_percent' && was > 0) {
    var pct = Math.round((saved / was) * 100);
    if (pct >= 1) return 'Save ' + pct + '%';
  }
  return 'Save ' + mmDiscountMoney(mmSaveRound(saved));
}

function renderItemSaveBadge(item, mode) {
  if (mode === 'off') return '';
  var s = computeItemSavings(item);
  if (!s.was) return '';
  var saved = s.was - s.now;
  if (saved <= 0) return '';
  return '<span class="mm-cart__item-save">' + mmSaveBadgeText(saved, s.was, mode) + '</span>';
}

// Purchase-type pill (replaces the old one-way "Subscribe & Save" toggle): a
// two-option segmented control under any line whose product can be bought
// both ways — one-time or on its first selling plan — so the shopper can
// flip a line in either direction. Spans the item's full grid row (below
// image/name/price). The saving shows on the plan option only when the plan
// is actually cheaper. Not offered for products that require a plan, for
// Kaching bundle lines (Kaching owns their pricing), or until the product
// data behind it has loaded (renderItems runs again once it has).
// Labels come from the drawer's data-pill-* attributes (Cart Drawer
// settings) and are plain text nodes, so assets/cart-es.js translates them.
function renderPurchasePill(item) {
  var drawer = document.getElementById('mm-cart');
  if (drawer && drawer.dataset.pillShow === 'false') return '';
  if (parseKachingBundle(item)) return '';
  var offer = getItemSubPlanOffer(item);
  var oneTime = variantPriceCache[item.variant_id];
  if (!offer || variantRequiresPlanCache[item.variant_id] !== false) return '';
  if (typeof oneTime !== 'number' || oneTime <= 0) return '';
  var onPlan = !!item.selling_plan_allocation;
  var perUnit = onPlan ? oneTime - item.price : item.price - offer.price;
  var save = perUnit > 0 ? mmSaveRound(perUnit * item.quantity) : 0;
  var labelOne = (drawer && drawer.dataset.pillOnetime) || 'One-time purchase';
  var labelPlan = (drawer && drawer.dataset.pillPlan) || 'Subscribe & Save';
  function seg(mode, on, label, extra) {
    return '<button type="button" class="mm-cart__pill-opt' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + (on ? 'true' : 'false') + '"' +
      ' data-mm-action="cart-purchase" data-key="' + item.key + '" data-mode="' + mode + '" data-plan="' + (mode === 'plan' ? offer.planId : '') + '">' +
      '<span class="mm-cart__pill-label">' + escapeHtml(label) + '</span>' + (extra || '') +
    '</button>';
  }
  return '<div class="mm-cart__pill" role="radiogroup" aria-label="Purchase type">' +
      seg('onetime', !onPlan, labelOne) +
      seg('plan', onPlan, labelPlan, save ? '<span class="mm-cart__pill-amt">' + mmDiscountMoney(save) + '</span>' : '') +
    '</div>';
}

/* ---- Kaching bundle grouping ---------------------------------------------
   Kaching tags every line it adds with a hidden `__kaching_bundles` property
   holding JSON; lines from the same add share an instance key ("id" on
   current builds, "bid" on some older ones). NOTE the counter-intuitive
   shape verified live (2026-08): for the Welcome Kit the widget marks the $0
   SUBSCRIPTION component (Foil Shaver Attachment, carries the selling plan)
   as {"main":true}, while the paid trimmer line carries {"bundleProduct"}.
   So "main" does NOT mean "the line to feature" — classification here is by
   PRICE: within an instance group the first PAID line is the anchor and
   every $0 line nests under it. Grouping on the shared id (rather than
   price alone) keeps this safe: two bundles can coexist, and a $0 line from
   a different app (no kaching property) is never swept under a trimmer. */
function parseKachingBundle(item) {
  var raw = item && item.properties && item.properties.__kaching_bundles;
  if (!raw || typeof raw !== 'string') return null;
  var data;
  try { data = JSON.parse(raw); } catch (e) { return null; }
  if (!data || typeof data !== 'object') return null;
  return {
    // Some deals ship no instance key at all — nothing to join on, so those
    // lines stay ungrouped rather than collapsing into one bogus group.
    id: typeof data.id === 'string' ? data.id
      : typeof data.bid === 'string' ? data.bid
      : ''
  };
}

function mmLineTotal(it) {
  return (typeof it.final_line_price === 'number') ? it.final_line_price
    : (typeof it.line_price === 'number') ? it.line_price
    : it.price * it.quantity;
}

// Ordered render list: [{ item, gifts: [...] }]. A bundle only nests when its
// group holds BOTH a paid anchor and at least one $0 component; an orphaned
// component keeps its own row (and therefore its own remove control) instead
// of becoming unreachable, and an anchor with no components renders exactly
// as it does today.
function buildCartRows(items) {
  var anchorFor = Object.create(null);
  var giftsFor = Object.create(null);

  items.forEach(function (it) {
    var kb = parseKachingBundle(it);
    if (kb && kb.id && mmLineTotal(it) > 0 && !anchorFor[kb.id]) anchorFor[kb.id] = it;
  });
  items.forEach(function (it) {
    var kb = parseKachingBundle(it);
    if (!kb || !kb.id || !anchorFor[kb.id]) return;
    if (mmLineTotal(it) === 0) (giftsFor[kb.id] = giftsFor[kb.id] || []).push(it);
  });

  var rows = [];
  items.forEach(function (it) {
    var kb = parseKachingBundle(it);
    if (!kb || !kb.id) { rows.push({ item: it, gifts: [] }); return; }
    if (mmLineTotal(it) === 0 && anchorFor[kb.id]) return; // nested under its anchor
    if (anchorFor[kb.id] === it) {
      rows.push({ item: it, gifts: giftsFor[kb.id] || [] });
      return;
    }
    rows.push({ item: it, gifts: [] });
  });
  return rows;
}

/* ---- ATC optimism / paid-line watchdog ------------------------------------
   One click on a Kaching-owned buybox can become TWO requests (see
   handleAtcSubmit): our form post — which the widget rewrites, often to the
   $0 gift components — and the widget's own partial post carrying the PAID
   line. If our reconcile lands between the two, the drawer shows a
   gifts-only cart; if the second post dies, the order really is missing the
   product. Everything here exists so the customer never sees — or checks
   out — that half-landed state:

     mmAddInFlight        the /cart/add.js request currently running, so
                          checkout waits for it instead of racing it
     mmPendingSetup       the optimistic stand-in (product + gifts) painted
                          on click; held on screen until the paid line is
                          confirmed server-side
     mmOrphanedGiftLines  $0 Kaching components with no paid anchor in their
                          group — the signature of a half-landed add */
var mmAddInFlight = null;
var mmPendingSetup = null; // { info, until, recovered }

function mmTrackAdd(promise) {
  mmAddInFlight = promise;
  var clear = function () { if (mmAddInFlight === promise) mmAddInFlight = null; };
  promise.then(clear, clear);
  return promise;
}

function mmOrphanedGiftLines() {
  var anchors = Object.create(null);
  CartState.items.forEach(function (it) {
    var kb = parseKachingBundle(it);
    if (kb && kb.id && mmLineTotal(it) > 0) anchors[kb.id] = true;
  });
  return CartState.items.filter(function (it) {
    var kb = parseKachingBundle(it);
    return kb && kb.id && mmLineTotal(it) === 0 && !anchors[kb.id];
  });
}

/* Called from renderItems after every server paint. While the click is still
   settling — the add request itself in flight, or the paid anchor missing —
   re-paint the stand-in setup over the incomplete server state, hiding the
   orphaned gift rows it already covers. Returns true when the stand-in owns
   the list; clears itself the moment the cart is whole (or on timeout). */
function mmReassertPendingSetup(container) {
  if (!mmPendingSetup) return false;
  if (mmPendingSetup.recovered || Date.now() > mmPendingSetup.until) {
    mmPendingSetup = null;
    return false;
  }
  var orphans = mmOrphanedGiftLines();
  if (!mmAddInFlight && !orphans.length) {
    mmPendingSetup = null;
    return false;
  }
  orphans.forEach(function (it) {
    var row = container.querySelector('.mm-cart__item[data-key="' + it.key + '"]');
    if (row) row.remove();
  });
  insertPendingLine(mmPendingSetup.info);
  return true;
}

/* ---- Kaching subscription swap ("what actually recurs") -------------------
   Kaching Subscriptions prints its selling-plan definitions on every page
   (app embed → <script id="kaching-subscriptions-config">). For swap-style
   bundle plans the interesting bit is automaticLineActionsPolicy: after
   cycle 1 the app REMOVES the bundled gift product and ADDS the recurring
   product (e.g. a fresh blade at $15.99). The cart line itself only names a
   cadence, so the drawer reads the policy to say what is actually delivered
   on that schedule. The swap variant's title/image aren't in the config —
   they're resolved once via the public Storefront token Kaching prints in
   #kaching-bundles-config (same source manmade-bundle-price.js uses) and
   cached in sessionStorage; until that lands the row shows the schedule
   line alone, which is still accurate. */
var mmSubsCfg; // parsed #kaching-subscriptions-config (null = absent/bad)
function mmKachingSubsConfig() {
  if (mmSubsCfg !== undefined) return mmSubsCfg;
  mmSubsCfg = null;
  try {
    var el = document.getElementById('kaching-subscriptions-config');
    if (el && el.textContent) mmSubsCfg = JSON.parse(el.textContent);
  } catch (e) { /* fall back to the raw plan-name display */ }
  return mmSubsCfg;
}

function mmPlanEveryText(delivery) {
  if (!delivery || !delivery.interval) return '';
  var unit = { DAY: 'day', WEEK: 'week', MONTH: 'month', YEAR: 'year' }[String(delivery.interval).toUpperCase()];
  if (!unit) return '';
  var n = Number(delivery.frequency) || 1;
  return 'every ' + (n > 1 ? n + ' ' + unit + 's' : unit);
}

/* Cadence of a cart line's selling plan as a bare phrase ("30 days",
   "month", "2 weeks") for the "Delivered every …" line. Sources, in order:
   the Kaching config printed on the page, the plan's own "config" option
   (/cart.js selling_plan.options carry the same delivery JSON — verified
   live: {"delivery":{"interval":"DAY","frequency":30},…}), then a "30-Day"
   style plan name. '' when nothing usable exists. */
function mmPlanCadenceText(sp) {
  if (!sp) return '';
  var every = '';
  var meta = sp.id ? mmKachingPlanMeta(sp.id) : null;
  if (meta && meta.every) every = meta.every;
  if (!every && Array.isArray(sp.options)) {
    for (var i = 0; i < sp.options.length && !every; i++) {
      var ov = sp.options[i] && sp.options[i].value;
      if (typeof ov !== 'string' || ov.charAt(0) !== '{') continue;
      try {
        var cfg = JSON.parse(ov);
        every = mmPlanEveryText(cfg && cfg.delivery);
      } catch (e) { /* not the config option */ }
    }
  }
  if (every) return every.replace(/^every\s+/, '');
  var m = /(\d+)\s*[- ]?\s*(day|week|month|year)s?\b/i.exec((sp.name || '') + ' ' + (sp.description || ''));
  if (m) {
    var n = parseInt(m[1], 10);
    var unit = m[2].toLowerCase();
    return n > 1 ? n + ' ' + unit + 's' : unit;
  }
  return '';
}

/* { every, variantId, priceCents } for a cart line's numeric selling-plan id,
   or null when the plan isn't in the Kaching config on this page. variantId
   is 0 for plain (no-swap) plans. */
function mmKachingPlanMeta(planId) {
  var cfg = mmKachingSubsConfig();
  var pc = cfg && cfg.sellingPlanConfigs &&
    cfg.sellingPlanConfigs['gid://shopify/SellingPlan/' + planId];
  if (!pc) return null;
  var meta = { every: mmPlanEveryText(pc.delivery), variantId: 0, priceCents: 0 };
  var pol = pc.automaticLineActionsPolicy || {};
  var cycles = Object.keys(pol).sort(function (a, b) { return a - b; });
  for (var i = 0; i < cycles.length && !meta.variantId; i++) {
    var acts = pol[cycles[i]] || [];
    for (var j = 0; j < acts.length; j++) {
      var act = acts[j];
      if (act && act.type === 'add' && act.variantId) {
        meta.variantId = act.variantId;
        if (act.discountPolicy && act.discountPolicy.type === 'PRICE') {
          meta.priceCents = Math.round(Number(act.discountPolicy.adjustmentValue) * 100);
        }
        break;
      }
    }
  }
  // Some plans price the recurring item on the plan itself instead of the
  // add action ("$0 today, $15.99/cycle after cycle 1").
  if (!meta.priceCents && pc.recurringDiscountAdjustment && pc.recurringDiscountAdjustment.type === 'PRICE') {
    meta.priceCents = Math.round(Number(pc.recurringDiscountAdjustment.adjustmentValue) * 100);
  }
  return meta;
}

var SWAP_CACHE_KEY = 'mm-kaching-swap-v1'; // sessionStorage: variantId -> {title, img}
var mmSwapInflight = {};
function mmSwapCacheGet(vid) {
  try { return (JSON.parse(sessionStorage.getItem(SWAP_CACHE_KEY)) || {})[vid] || null; }
  catch (e) { return null; }
}
function mmSwapCachePut(vid, entry) {
  try {
    var all = JSON.parse(sessionStorage.getItem(SWAP_CACHE_KEY)) || {};
    all[vid] = entry;
    sessionStorage.setItem(SWAP_CACHE_KEY, JSON.stringify(all));
  } catch (e) { /* private mode etc. — refetched next render */ }
}

/* Resolve a swap variant's product title/image once, then patch every
   rendered swap row in place (render() may have painted before this lands;
   the cache makes all later renders synchronous). */
function mmResolveSwapVariant(vid) {
  if (mmSwapCacheGet(vid) || mmSwapInflight[vid]) return;
  var domain, token;
  try {
    var cfg = JSON.parse(document.getElementById('kaching-bundles-config').textContent);
    domain = cfg.shopifyDomain;
    token = cfg.storefrontAccessToken;
  } catch (e) { return; }
  if (!domain || !token) return;
  mmSwapInflight[vid] = true;
  var query = '{node(id:"gid://shopify/ProductVariant/' + vid + '"){... on ProductVariant{product{title}image{url}}}}';
  fetch('https://' + domain + '/api/2026-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token
    },
    body: JSON.stringify({ query: query })
  })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      var node = data && data.data && data.data.node;
      if (!node || !node.product || !node.product.title) return;
      var entry = { title: node.product.title, img: (node.image && node.image.url) || '' };
      mmSwapCachePut(vid, entry);
      mmPatchSwapRows(vid, entry);
    })
    .catch(function () { /* schedule-only row remains — still accurate */ })
    .then(function () { delete mmSwapInflight[vid]; });
}

function mmPatchSwapRows(vid, entry) {
  document.querySelectorAll('[data-mm-swap="' + vid + '"]').forEach(function (row) {
    var nameEl = row.querySelector('[data-mm-swap-name]');
    if (nameEl) nameEl.textContent = entry.title;
    var ph = row.querySelector('[data-mm-swap-img]');
    if (ph && entry.img && ph.tagName !== 'IMG') {
      var img = document.createElement('img');
      img.className = 'mm-cart__gift-img';
      img.src = entry.img.replace(/\.([^.]+)$/, '_80x80.$1');
      img.alt = '';
      img.width = 32;
      img.height = 32;
      img.loading = 'lazy';
      img.setAttribute('data-mm-swap-img', '');
      ph.replaceWith(img);
    }
  });
}

// The recurring (post-swap) product as its own row under the gift it will
// replace: what arrives on the schedule, how often, at what recurring price.
function renderGiftSwapRow(meta) {
  var vid = String(meta.variantId);
  var cached = mmSwapCacheGet(vid);
  if (!cached) mmResolveSwapVariant(vid);
  var media = cached && cached.img
    ? '<img class="mm-cart__gift-img" data-mm-swap-img src="' + cached.img.replace(/\.([^.]+)$/, '_80x80.$1') + '" alt="" width="32" height="32" loading="lazy">'
    : '<span class="mm-cart__gift-img mm-cart__gift-img--ph" data-mm-swap-img aria-hidden="true"></span>';
  var schedule = 'Delivered ' + meta.every +
    (meta.priceCents ? ' · ' + formatMoney(meta.priceCents) : '');
  return '<li class="mm-cart__gift mm-cart__gift--swap" data-mm-swap="' + vid + '">' +
      media +
      '<span class="mm-cart__gift-meta">' +
        '<span class="mm-cart__gift-name" data-mm-swap-name>' + escapeHtml(cached && cached.title ? cached.title : '') + '</span>' +
        '<span class="mm-cart__gift-plan">' +
          '<svg class="mm-cart__gift-swap-ic" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
            '<path d="M2.7 8a5.3 5.3 0 0 1 9-3.8l1.6 1.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M13.3 8a5.3 5.3 0 0 1-9 3.8l-1.6-1.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M13.6 2.3v3.4h-3.4M2.4 13.7v-3.4h3.4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
          escapeHtml(schedule) +
        '</span>' +
        subPolicyLinkHtml() +
      '</span>' +
    '</li>';
}

// Sub-rows for the free add-ons that came with a bundle. No quantity stepper —
// the bundle owns the quantity. FREE rows get no remove control either: an ×
// on a $0 line reads as "am I paying for this? do I need to decide?" — and an
// orphaned gift is never stuck, because a component without a paid anchor
// renders as its own top-level row with a normal remove (see buildCartRows).
// Merely-discounted components still cost money, so they keep the ×.
function renderBundleGifts(gifts) {
  if (!gifts || !gifts.length) return '';
  // "Your 2 free gifts" beats "Included with this bundle" — but only when the
  // whole group really is free; a mix of free + discounted keeps the generic
  // label rather than miscounting.
  var freeQty = 0;
  var allFree = true;
  gifts.forEach(function (g) {
    if (g.final_line_price === 0) freeQty += Math.max(1, g.quantity || 1);
    else allFree = false;
  });
  var label = allFree && freeQty > 0
    ? (freeQty === 1 ? 'Your free gift' : 'Your ' + freeQty + ' free gifts')
    : 'Included with this bundle';
  var rows = gifts.map(function (g) {
    var media = g.featured_image && g.featured_image.url
      ? '<img class="mm-cart__gift-img" src="' + g.featured_image.url.replace(/\.([^.]+)$/, '_80x80.$1') + '" alt="" width="32" height="32" loading="lazy">'
      : '<span class="mm-cart__gift-img mm-cart__gift-img--ph" aria-hidden="true"></span>';
    var qty = g.quantity > 1 ? ' <span class="mm-cart__gift-qty">×' + g.quantity + '</span>' : '';
    // Free is the common case, but a bundle component can be merely
    // discounted — show whatever the line actually costs.
    var price = g.final_line_price === 0
      ? (g.original_line_price > 0 ? '<span class="mm-cart__gift-was">' + formatMoney(g.original_line_price) + '</span>' : '') +
        '<span class="mm-cart__gift-free">Free</span>'
      : '<span class="mm-cart__gift-now">' + formatMoney(g.final_line_price) + '</span>';
    // The subscription rides on the COMPONENT line (verified live: the free
    // Foil Shaver carries the "every 2 months" plan, the trimmer doesn't).
    // But the plan's cadence describes the post-swap RECURRING product, not
    // this gift — the gift ships once and Kaching's line action swaps it out
    // after cycle 1. So: tag the free line "Free gift", and give the actual
    // recurring product its own row (renderGiftSwapRow). A plan with no swap
    // policy keeps a cadence line here; a plan missing from the Kaching
    // config falls back to the raw plan name as before.
    var spa = g.selling_plan_allocation;
    var plan = '';
    var swapRow = '';
    if (spa && spa.selling_plan) {
      var meta = mmKachingPlanMeta(spa.selling_plan.id);
      if (meta && meta.variantId && meta.every) {
        swapRow = renderGiftSwapRow(meta);
      } else if (meta && meta.every) {
        plan = '<span class="mm-cart__gift-plan">Delivered ' + escapeHtml(meta.every) + '</span>';
      } else if (spa.selling_plan.name) {
        plan = '<span class="mm-cart__gift-plan">' + escapeHtml(spa.selling_plan.name) + '</span>';
      }
    }
    // No "Free gift" chip next to the name — the group label ("Your N free
    // gifts") and the price column's struck-price + FREE already say it;
    // a third mention just crowds the title.
    var removeBtn = g.final_line_price === 0
      ? ''
      : '<button type="button" class="mm-cart__gift-remove" data-mm-action="cart-qty"' +
          ' data-key="' + g.key + '" data-delta="-' + g.quantity + '"' +
          ' aria-label="Remove ' + escapeHtml(g.title) + ' from cart">' +
          '<svg viewBox="0 0 16 16" width="10" height="10" fill="none" aria-hidden="true">' +
            '<path d="M3.5 3.5l9 9M12.5 3.5l-9 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>';
    return '<li class="mm-cart__gift" data-key="' + g.key + '">' +
        media +
        '<span class="mm-cart__gift-meta">' +
          '<span class="mm-cart__gift-name">' + escapeHtml(g.title) + qty + '</span>' +
          plan +
        '</span>' +
        '<span class="mm-cart__gift-price">' + price + '</span>' +
        removeBtn +
      '</li>' +
      swapRow;
  }).join('');
  return '<ul class="mm-cart__gifts" role="list">' +
      '<li class="mm-cart__gifts-label" aria-hidden="true">' + label + '</li>' +
      rows +
    '</ul>';
}

// Per-unit savings for a line. Kept per-unit (rather than per-line) so the
// footer badge can be recomputed against an optimistic quantity mid-click,
// exactly like updateLineDom() scales the row's own "was"/"Save" figures.
function getItemUnitSavings(item) {
  if (!item.quantity) return 0;
  var s = computeItemSavings(item);
  if (!s.was) return 0;
  var saved = s.was - s.now;
  return saved > 0 ? saved / item.quantity : 0;
}

// Totals block — Subtotal (before discounts) / Discounts (−$X) / Total.
// renderCartSavings owns the discount figure (exact cents — it must add up
// next to the total, unlike the $5-rounded line badges; qtyFor lets the
// optimistic path substitute a pending quantity), mmPaintCartTotal owns the
// total, and mmPaintPreSubtotal derives the pre-discount Subtotal from the
// two. The upper rows hide when nothing is discounted, so an undiscounted
// cart reads as a single Total line.
var mmCartTotalCents = 0;
var mmCartSavedCents = 0;
function mmPaintPreSubtotal() {
  // Discounts row: "−$44.01 (56%)" — the % is against the pre-discount gross
  // (total + saved), so it matches the line badges' compare-at math.
  var d = document.getElementById('mm-cart-savings');
  if (d && mmCartSavedCents > 0) d.textContent = '−' + formatMoney(mmCartSavedCents);
  // "SAVE 56%" chip left of the Total amount (pct vs the pre-discount gross)
  var chip = document.getElementById('mm-cart-save-chip');
  if (chip) {
    var gross = mmCartTotalCents + mmCartSavedCents;
    var pct = (mmCartSavedCents > 0 && gross > 0) ? Math.round(mmCartSavedCents * 100 / gross) : 0;
    chip.hidden = pct <= 0;
    if (pct > 0) chip.textContent = 'Save ' + pct + '%';
  }
  // Optional pre-discount Subtotal row (not in the current drawer markup).
  var el = document.getElementById('mm-cart-presub');
  if (!el) return;
  var rowEl = el.closest('[data-mm-cart-presub-row]') || el;
  if (mmCartSavedCents > 0) {
    el.textContent = formatMoney(mmCartTotalCents + mmCartSavedCents);
    rowEl.hidden = false;
  } else {
    el.textContent = '';
    rowEl.hidden = true;
  }
}

function renderCartSavings(items, qtyFor) {
  var el = document.getElementById('mm-cart-savings');
  if (!el) return;
  var rowEl = el.closest('[data-mm-cart-discount-row]') || el;
  var saved = items.reduce(function (sum, it) {
    var qty = qtyFor ? qtyFor(it) : it.quantity;
    return sum + getItemUnitSavings(it) * Math.max(0, qty);
  }, 0);
  saved = Math.round(saved);
  mmCartSavedCents = saved > 0 ? saved : 0;
  if (saved <= 0) {
    el.textContent = '';
    rowEl.hidden = true;
  } else {
    el.textContent = '−' + formatMoney(saved);
    rowEl.hidden = false;
  }
  mmPaintPreSubtotal();
}

// Paints the Total row (and, via mmPaintPreSubtotal, the Subtotal above
// it). The checkout button no longer repeats the amount — it reads lock ·
// SECURE CHECKOUT · arrow — but any [data-mm-checkout-amt] still present in
// a template keeps receiving the figure.
/* Days of supply behind one cart line, matching the PDP offer cards: a
   resupply line covers its delivery cadence per bag; a one-time line covers
   servings (product record, printed as window.mmServingsByProduct) per bag.
   Either way every extra bag adds its own days of supply (bags are taken
   back to back, not together), so the per-day cost doesn't move with qty. */
function mmLineSupplyDays(item) {
  var qty = Math.max(1, item.quantity || 1);
  var spa = item.selling_plan_allocation;
  if (spa && spa.selling_plan) {
    var m = /^(\d+)?\s*(day|week|month|year)/.exec(mmPlanCadenceText(spa.selling_plan));
    if (m) return (parseInt(m[1], 10) || 1) * { day: 1, week: 7, month: 30, year: 365 }[m[2]] * qty;
  }
  var map = window.mmServingsByProduct || {};
  var srv = Number(map[item.product_id]) || Number(map._default) || 0;
  return srv > 0 ? srv * qty : 0;
}

/* Cart cost per day: per product, Σ line total ÷ Σ line days (so two lines of
   the same product — one-time + resupply, or the same bag in several lines —
   never count as taking it twice); different products add. Scaled to the
   painted total so optimistic paints stay in step. 0 when a paid line has
   no supply or nothing is paid. */
function mmCartPerDayCents(cents) {
  var items = (typeof CartState !== 'undefined' && CartState.items) || [];
  var sum = 0, perDay = 0, unknown = false, byProduct = {};
  items.forEach(function (it) {
    var line = typeof it.final_line_price === 'number' ? it.final_line_price : it.price * it.quantity;
    if (line <= 0) return;
    var days = mmLineSupplyDays(it);
    if (days <= 0) { unknown = true; return; }
    var g = byProduct[it.product_id] || (byProduct[it.product_id] = { line: 0, days: 0 });
    g.line += line;
    g.days += days;
    sum += line;
  });
  Object.keys(byProduct).forEach(function (k) { perDay += byProduct[k].line / byProduct[k].days; });
  if (unknown || sum <= 0 || perDay <= 0) return 0;
  return Math.round(cents * perDay / sum);
}

function mmPaintCartTotal(subtotalEl, cents) {
  var txt = formatMoney(cents);
  mmCartTotalCents = cents;
  var perDay = mmCartPerDayCents(cents);
  var fullEl = document.getElementById('mm-cart-total-full');
  if (subtotalEl) {
    subtotalEl.textContent = perDay > 0 ? formatMoney(perDay) + '/day' : txt;
    subtotalEl.removeAttribute('aria-label');
  }
  if (fullEl) { fullEl.textContent = txt + ' total'; fullEl.hidden = !(perDay > 0); }
  document.querySelectorAll('[data-mm-checkout-amt]').forEach(function (el) {
    el.textContent = txt;
    el.hidden = false;
  });
  mmPaintPreSubtotal();
}

function renderItemPrice(item, mode) {
  var s = computeItemSavings(item);
  var now = s.now;
  var was = s.was;

  if (!was || mode === 'off') {
    return '<div class="mm-cart__item-price"><span class="mm-cart__item-now">' + formatMoney(now) + '</span></div>';
  }

  return '<div class="mm-cart__item-price mm-cart__item-price--stacked">' +
    '<span class="mm-cart__item-now">' + formatMoney(now) + '</span>' +
    '<span class="mm-cart__item-was">' + formatMoney(was) + '</span>' +
  '</div>';
}

// The threshold gift's price cell: FREE over the struck value when the line
// really is $0, otherwise the normal price — an honest fallback for a gift
// whose Shopify discount isn't set up yet.
function renderGiftLinePrice(item, mode) {
  var now = mmLineTotal(item);
  if (now > 0) return renderItemPrice(item, mode);
  var was = 0;
  if (mode !== 'off') {
    was = (typeof item.original_line_price === 'number' && item.original_line_price > 0)
      ? item.original_line_price
      : (getItemComparePrice(item) || 0) * item.quantity;
  }
  return '<div class="mm-cart__item-price' + (was ? ' mm-cart__item-price--stacked' : '') + '">' +
    '<span class="mm-cart__item-now mm-cart__item-now--free">Free</span>' +
    (was ? '<span class="mm-cart__item-was">' + formatMoney(was) + '</span>' : '') +
  '</div>';
}

// Shopify's /cart.js already HTML-encodes titles ("EMS &amp; Red Light"), so
// decode any entities first; escaping the decoded text is then correct
// for both encoded API strings and raw ones (a plain "&" survives decode).
var mmDecodeEl;
function decodeHtml(str) {
  str = String(str);
  if (str.indexOf('&') === -1) return str;
  mmDecodeEl = mmDecodeEl || document.createElement('textarea');
  mmDecodeEl.innerHTML = str;
  return mmDecodeEl.value;
}
function escapeHtml(str) {
  return decodeHtml(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Subtle "Learn more about this subscription" link for subscription cart rows.
// Same .mm-subpolicy markup the Liquid snippet emits, so the global reader
// modal (snippets/subscription-policy-modal.liquid) intercepts the click and
// the shared styles apply. The href is the no-JS fallback; the URL mirrors the
// modal's data-policy-url (theme setting), falling back to the policy page.
function subPolicyLinkHtml() {
  var m = document.getElementById('mm-subpolicy-modal');
  var url = (m && m.getAttribute('data-policy-url')) || '/policies/subscription-policy';
  return '<a class="mm-subpolicy mm-subpolicy--cart" href="' + escapeHtml(url) + '" target="_blank" rel="noopener">' +
    '<svg class="mm-subpolicy__ic" viewBox="0 0 16 16" width="13" height="13" fill="none" aria-hidden="true">' +
      '<circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.4"/>' +
      '<path d="M8 7.2v4M8 4.9h.01" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '</svg>' +
    '<span class="mm-subpolicy__text">Resupply policy</span>' +
  '</a>';
}

/* ----------------------------------------------------------
   7. CART DRAWER
   ---------------------------------------------------------- */
var cartDrawerOpen = false;
var lastFocusedCart = null;
var scrollLockY = 0;

/* Page scroll lock, keyed by OWNER rather than a bare counter. The old
   counter stranded the page: openCart() ran twice for one close (optimistic
   open on click + a second open after /cart/add.js landed, e.g. pdp-mm15.js
   addToCart → afterAdd), the count reached 2, one close left it at 1, and
   <body> stayed position:fixed — the "can't scroll the site" bug. An owner
   can hold the lock once, so a repeated open is a no-op and a single close
   always releases that owner. The page unlocks when the LAST owner lets go.
   Other overlays (mm-policy-modal.js) share this via window.lockBodyScroll. */
var scrollLockOwners = [];

function lockBodyScroll(owner) {
  owner = owner || 'default';
  if (scrollLockOwners.indexOf(owner) !== -1) return; // already holds it
  scrollLockOwners.push(owner);
  if (scrollLockOwners.length > 1) return;            // page already locked
  scrollLockY = window.scrollY || window.pageYOffset || 0;
  var body = document.body;
  body.style.position = 'fixed';
  body.style.top = '-' + scrollLockY + 'px';
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  body.style.overflow = 'hidden';
}

function unlockBodyScroll(owner) {
  owner = owner || 'default';
  var i = scrollLockOwners.indexOf(owner);
  if (i !== -1) scrollLockOwners.splice(i, 1);
  if (scrollLockOwners.length) return;                // someone else still holds it
  var body = document.body;
  var wasLocked = body.style.position === 'fixed';
  body.style.position = '';
  body.style.top = '';
  body.style.left = '';
  body.style.right = '';
  body.style.width = '';
  body.style.overflow = '';
  if (wasLocked) window.scrollTo(0, scrollLockY);
}

/* Last-resort release: no owner left open → drop every style the lock set.
   Cheap enough to call from any "everything closed" path. */
function releaseBodyScrollIfIdle() {
  if (cartDrawerOpen || navDrawerOpen || AddonPeek.open) return;
  if (document.querySelector('#mm-subpolicy-modal.is-open')) return;
  scrollLockOwners.length = 0;
  unlockBodyScroll();
}

/* Reservation countdown — sessionStorage-backed cart-hold timer.
   The timer starts the first time the drawer opens this session, persists
   across page navigations, and shows an expired state at 00:00. */
var CartReserve = (function () {
  var STORAGE_KEY = 'mm-cart-reserve-expiry-v1';
  var el = null, labelEl = null, timeEl = null;
  var activeLabel = '', expiredLabel = '', minutes = 10;
  var expiry = 0;
  var iv = null;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function read() {
    try {
      var v = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
      return isNaN(v) ? 0 : v;
    } catch (e) { return 0; }
  }
  function write(v) {
    try { sessionStorage.setItem(STORAGE_KEY, String(v)); } catch (e) {}
  }

  function render() {
    if (!el || !timeEl) return;
    var rem = expiry - Date.now();
    if (rem <= 0) {
      timeEl.textContent = '00:00';
      el.setAttribute('data-expired', '');
      if (labelEl && expiredLabel) labelEl.textContent = expiredLabel;
      stop();
      return;
    }
    el.removeAttribute('data-expired');
    if (labelEl && activeLabel) labelEl.textContent = activeLabel;
    var mins = Math.floor(rem / 60000);
    var secs = Math.floor((rem % 60000) / 1000);
    timeEl.textContent = pad(mins) + ':' + pad(secs);
  }

  function start() {
    if (!el) init();
    if (!el) return;
    if (!expiry) {
      expiry = read();
      if (!expiry || expiry < Date.now()) {
        expiry = Date.now() + minutes * 60 * 1000;
        write(expiry);
      }
    }
    render();
    if (iv) return;
    iv = setInterval(render, 1000);
  }
  function stop() {
    if (iv) { clearInterval(iv); iv = null; }
  }

  function init() {
    el = document.querySelector('[data-mm-reserve]');
    if (!el) return;
    labelEl = el.querySelector('[data-mm-reserve-label]');
    timeEl  = el.querySelector('[data-mm-reserve-time]');
    activeLabel  = el.getAttribute('data-active-label')  || '';
    expiredLabel = el.getAttribute('data-expired-label') || '';
    minutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;
  }

  return { start: start, stop: stop, init: init };
})();

/* Leave for /checkout only once the cart really holds what the drawer shows:
   wait out any in-flight add, and if this click's paid line is still
   unconfirmed, spend one round trip verifying (and recovering) it. Capped at
   4s — an instant redirect in the healthy case, never a hostage in the bad
   one. */
/* Checkout in the storefront's language. Shopify ignores /es/checkout (it
   lands on /en-us); only /checkout?locale=es opens the Spanish checkout
   (verified 2026-10-04). Spanish = the /es/ storefront, or a Spanish-mode page
   outside it (15-in-1 Spanish template, assets/pdp-mm15-es.js) on a domain
   that has Spanish published. */
function mmCheckoutUrl() {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var es = root === '/es/' ||
    (document.documentElement.lang === 'es' && window.__m15Lang && window.__m15Lang.esRoot) ||
    document.documentElement.classList.contains('mm-es');
  return '/checkout' + (es ? '?locale=es' : '');
}

/* Checkout button feedback: the wait below can run up to 4s, and a button
   that does nothing for that long reads as dead (replay sessions showed
   shoppers tapping cart controls and leaving). Shows "Processing…" at once;
   the 8s timer hands the button back if the page never navigated. */
function mmCheckoutBusy(btn, on, msg) {
  if (!btn) return;
  var labelEl = btn.querySelector('.mm-btn__label') || btn;
  if (on) {
    if (btn.__mmCoOrig === undefined) btn.__mmCoOrig = labelEl.textContent;
    labelEl.textContent = 'Processing…';
    btn.setAttribute('aria-busy', 'true');
    clearTimeout(btn.__mmCoTimer);
    btn.__mmCoTimer = setTimeout(function () { mmCheckoutBusy(btn, false); }, 8000);
  } else {
    clearTimeout(btn.__mmCoTimer);
    if (btn.__mmCoOrig !== undefined) labelEl.textContent = btn.__mmCoOrig;
    btn.__mmCoOrig = undefined;
    btn.removeAttribute('aria-busy');
  }
  if (msg) showCartError(msg);
}

function mmGoCheckout(btn) {
  if (btn && btn.getAttribute('aria-busy') === 'true') return; // already on its way
  mmCheckoutBusy(btn, true);
  var go = function () { window.location.href = mmCheckoutUrl(); };
  var addFailed = false;
  var settled = mmAddInFlight
    ? mmAddInFlight.then(function (r) { if (r && r.ok === false) addFailed = true; }, function () { addFailed = true; })
    : Promise.resolve();
  var verified = settled.then(function () {
    if (!mmPendingSetup) return;
    return CartState.fetch().then(function () {
      if (mmOrphanedGiftLines().length) return mmRecoverPaidLine();
    });
  });
  Promise.race([
    verified.then(function () {}, function () {}),
    new Promise(function (resolve) { setTimeout(resolve, 4000); })
  ]).then(function () {
    if (!addFailed) return go();
    // The add this click was waiting on failed: leave only if the cart still
    // holds something — never hand Shopify an empty cart.
    return fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (c && c.item_count > 0) go();
        else mmCheckoutBusy(btn, false, 'Couldn’t add that item — please try again.');
      }, go);
  });
}

function openCart() {
  var drawer = document.getElementById('mm-cart');
  var scrim = document.querySelector('[data-mm-cart-scrim]');
  if (!drawer) return;

  // Re-opening an open drawer (optimistic open + post-add open for the same
  // click) must not re-take the lock or overwrite the restore-focus target.
  var wasOpen = cartDrawerOpen && drawer.hasAttribute('data-open');
  if (!wasOpen) lastFocusedCart = document.activeElement;
  drawer.setAttribute('data-open', '');
  drawer.setAttribute('aria-hidden', 'false');
  if (scrim) { scrim.setAttribute('data-open', ''); scrim.setAttribute('aria-hidden', 'false'); }
  lockBodyScroll('cart');
  cartDrawerOpen = true;

  CartReserve.start();

  requestAnimationFrame(function() {
    var closeBtn = drawer.querySelector('[data-mm-action="close-cart"]');
    if (closeBtn) closeBtn.focus();
  });

  trapFocus(drawer);
}

function closeCart() {
  var drawer = document.getElementById('mm-cart');
  var scrim = document.querySelector('[data-mm-cart-scrim]');
  if (!drawer) return;
  // Closing an already-closed drawer (error path, editor deselect) must not
  // touch the lock or jump the page to a stale scroll position.
  if (!cartDrawerOpen && !drawer.hasAttribute('data-open')) { releaseBodyScrollIfIdle(); return; }

  drawer.removeAttribute('data-open');
  drawer.setAttribute('aria-hidden', 'true');
  if (scrim) { scrim.removeAttribute('data-open'); scrim.setAttribute('aria-hidden', 'true'); }
  cartDrawerOpen = false;
  unlockBodyScroll('cart');

  CartReserve.stop();

  removeTrapFocus(drawer);
  if (lastFocusedCart) { lastFocusedCart.focus(); lastFocusedCart = null; }
}

/* ----------------------------------------------------------
   8. MOBILE DRAWER
   ---------------------------------------------------------- */
var navDrawerOpen = false;
var lastFocusedDrawer = null;

function openDrawer() {
  var drawer = document.getElementById('mm-drawer');
  var scrim = document.querySelector('[data-mm-drawer-scrim]');
  var btn = document.querySelector('[data-mm-action="open-drawer"]');
  if (!drawer) return;

  if (!navDrawerOpen) lastFocusedDrawer = document.activeElement;
  drawer.setAttribute('data-open', '');
  drawer.setAttribute('aria-hidden', 'false');
  if (scrim) scrim.setAttribute('data-open', '');
  if (btn) btn.setAttribute('aria-expanded', 'true');
  lockBodyScroll('nav');
  navDrawerOpen = true;

  requestAnimationFrame(function() { drawer.focus(); });
  trapFocus(drawer);
}

function closeDrawer() {
  var drawer = document.getElementById('mm-drawer');
  var scrim = document.querySelector('[data-mm-drawer-scrim]');
  var btn = document.querySelector('[data-mm-action="open-drawer"]');
  if (!drawer) return;
  if (!navDrawerOpen && !drawer.hasAttribute('data-open')) { releaseBodyScrollIfIdle(); return; }

  drawer.removeAttribute('data-open');
  drawer.setAttribute('aria-hidden', 'true');
  if (scrim) scrim.removeAttribute('data-open');
  if (btn) btn.setAttribute('aria-expanded', 'false');
  navDrawerOpen = false;
  unlockBodyScroll('nav');

  removeTrapFocus(drawer);
  if (lastFocusedDrawer) { lastFocusedDrawer.focus(); lastFocusedDrawer = null; }
}

/* ----------------------------------------------------------
   9. FOCUS TRAP
   ---------------------------------------------------------- */
var focusTrapHandler = null;

function trapFocus(el) {
  var focusable = el.querySelectorAll(
    'a[href], button:not([disabled]), input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
  );
  var first = focusable[0];
  var last = focusable[focusable.length - 1];

  removeTrapFocus(el);

  focusTrapHandler = function(e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  el.addEventListener('keydown', focusTrapHandler);
}

function removeTrapFocus(el) {
  if (focusTrapHandler) {
    el.removeEventListener('keydown', focusTrapHandler);
    focusTrapHandler = null;
  }
}

/* ----------------------------------------------------------
   10. ADD TO CART
   ---------------------------------------------------------- */
async function addToCart(variantIds) {
  if (!variantIds) {
    showCartError('Please select a variant before adding to cart.');
    return;
  }

  var ids = String(variantIds).split(',').map(function(id) { return id.trim(); }).filter(Boolean);
  if (!ids.length) {
    showCartError('Please select a variant before adding to cart.');
    return;
  }

  var body = JSON.stringify({ items: ids.map(function(id) { return { id: parseInt(id, 10), quantity: 1 }; }) });

  // Open first, add behind it — the drawer appearing IS the click feedback.
  // Buttons on this path carry only variant ids (no title/image), so there is
  // no stand-in row; the line pops in when the reconcile lands (~one round
  // trip after the add).
  clearCartError();
  openCart();

  try {
    var res = await mmTrackAdd(fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    }));

    if (!res.ok) {
      var err = await res.json();
      showCartError(err.description || 'Could not add item to cart. Please try again.');
      return;
    }

    await CartState.fetch();
    clearCartError();
  } catch (e) {
    showCartError('A network error occurred. Please check your connection and try again.');
  }
}

/* Kaching selling-plan failsafe. When the Kaching Bundles widget owns this
   buybox it maintains a `properties[__kaching_bundles]` input in the form and
   stamps the ACTIVE selling-plan id as `data-selling-plan-id` on its block
   (cleared for one-time bars — same DOM contract pdp-bundle-sub-footer relies
   on). Kaching's cart interceptor (a window.fetch patch) normally injects the
   plan + bundle components into our /cart/add.js post, but when that
   interception misses (script-load race, A/B variant re-render) the add lands
   as a bare full-price one-time line — no plan, no discount. Appending the
   stamped plan id ourselves guarantees the subscription terms and pricing
   either way; when Kaching's merge DOES run it rebuilds the items and simply
   supersedes this field. */
function mmKachingPlanFailsafe(form, fd) {
  try {
    if (!form.querySelector('[name="properties[__kaching_bundles]"]')) return;
    if (fd.get('selling_plan')) return; // widget (or its interceptor) already set it
    var el = form.querySelector('[data-selling-plan-id]') ||
             document.querySelector('.kaching-bundles__block[data-selling-plan-id]');
    var raw = el ? el.getAttribute('data-selling-plan-id') : '';
    var id = (String(raw).match(/\d{3,}/) || [''])[0];
    if (id) fd.append('selling_plan', id);
  } catch (e) { /* never block the add */ }
}

/* Post-add watchdog. Our request resolving does NOT mean the click is done —
   Kaching may still be posting the paid line from its own partial request.
   Re-check the cart a few times (most misses are just that race, and the
   next /cart.js shows the full setup); only when the paid anchor never
   arrives do we add the product ourselves. The stand-in row stays painted
   throughout, so the customer only ever sees their setup. */
var MM_ENSURE_DELAYS = [600, 1100, 1900];
function mmEnsureSetupLanded(attempt) {
  if (!mmPendingSetup || mmPendingSetup.recovered) return;
  if (!mmOrphanedGiftLines().length) return; // paid anchor landed — healthy
  if (attempt >= MM_ENSURE_DELAYS.length) { mmRecoverPaidLine(); return; }
  setTimeout(function () {
    if (!mmPendingSetup) return;
    CartState.fetch().then(function () { mmEnsureSetupLanded(attempt + 1); });
  }, MM_ENSURE_DELAYS[attempt]);
}

/* The PDP's paid variant. Kaching's product JSON is the authority when the
   widget owns the buybox — the form's `id` input can hold a $0 component
   (verified live: Welcome Kit posts the foil shaver, not the trimmer). */
function mmMainPaidVariant() {
  try {
    var prodEl = document.querySelector('.kaching-bundles-product[data-main="true"]') ||
                 document.querySelector('.kaching-bundles-product');
    if (prodEl) {
      var prod = JSON.parse(prodEl.textContent);
      var variants = prod.variants || [];
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === prod.selectedVariantId) return { id: variants[i].id, price: variants[i].price };
      }
      if (variants.length) return { id: variants[0].id, price: variants[0].price };
    }
  } catch (e) { /* fall through to the theme form */ }
  var form = document.querySelector('[data-mm-product-form]');
  var idInput = form ? form.querySelector('[data-mm-variant-id]') : null;
  var vid = idInput ? parseInt(idInput.value, 10) : 0;
  return vid ? { id: vid, price: parseInt(form.dataset.mmProductPrice, 10) || 0 } : null;
}

/* Last resort: the paid line never landed, so post it ourselves — a plain
   JSON add Kaching's interceptor ignores, carrying the widget's stamped
   selling plan so subscription pricing stays correct. The gifts are already
   in the cart (they're what DID land); worst case they render as their own
   rows instead of nesting, but the order is complete and checkout-able. */
function mmRecoverPaidLine() {
  // Once per click — the watchdog and the checkout gate can both get here.
  if (mmPendingSetup) {
    if (mmPendingSetup.recovered) return Promise.resolve();
    mmPendingSetup.recovered = true;
  }
  var main = mmMainPaidVariant();
  if (!main || !main.id || !(main.price > 0)) return Promise.resolve();
  var landed = CartState.items.some(function (it) {
    return it.variant_id === main.id && mmLineTotal(it) > 0;
  });
  if (landed) return Promise.resolve();
  var body = { id: main.id, quantity: 1 };
  var el = document.querySelector('[data-mm-product-form] [data-selling-plan-id], .kaching-bundles__block[data-selling-plan-id]');
  var planId = el ? (String(el.getAttribute('data-selling-plan-id') || '').match(/\d{3,}/) || [''])[0] : '';
  if (planId) body.selling_plan = planId;
  return mmTrackAdd(fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body)
  }))
    .then(function () { return CartState.fetch(); })
    .catch(function () { /* server truth is already rendered */ });
}

/* ----------------------------------------------------------
   10x. BUY NOW — add the form's selection, then jump straight
   to checkout instead of opening the cart drawer.
   ---------------------------------------------------------- */
async function buyNow(form, btn) {
  if (form.__mmLocked) return; // an ATC submit or buy-now is already in flight
  form.__mmLocked = true;
  var labelEl = btn.querySelector('.mm-btn__label') || btn;
  var origText = labelEl.textContent;
  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');
  labelEl.textContent = 'Processing…';
  var restore = function() {
    form.__mmLocked = false;
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    labelEl.textContent = origText;
  };

  try {
    var bundleMode = form.dataset.mmBundleMode;
    var kitVariants = form.dataset.mmKitVariants;
    var res;

    if (bundleMode === 'kit' && kitVariants) {
      var ids = String(kitVariants).split(',').map(function(id) { return id.trim(); }).filter(Boolean);
      res = await mmTrackAdd(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function(id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
      }));
    } else {
      // Same purchase-mode reconcile as the ATC submit handler — guarantees
      // "one-time" never posts selling_plan and "subscribe" posts the shown plan.
      form.querySelectorAll('[data-mm-sub]').forEach(function(group) {
        mmApplySubMode(group, mmSubMode(group));
      });
      var fdBuy = new FormData(form);
      mmKachingPlanFailsafe(form, fdBuy);
      res = await mmTrackAdd(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fdBuy
      }));
    }

    if (!res.ok) {
      var err = await res.json();
      showCartError(err.description || 'Could not start checkout. Please try again.');
      restore();
      return;
    }
    clearCartError();
    // Kaching-owned buybox: our request resolving doesn't mean the PAID line
    // landed — the widget posts it separately, and leaving now can check out
    // the gifts without the product. One round trip verifies (and recovers)
    // before we go; non-Kaching forms skip straight to checkout.
    if (form.querySelector('[name="properties[__kaching_bundles]"]')) {
      try {
        await CartState.fetch();
        if (mmOrphanedGiftLines().length) await mmRecoverPaidLine();
      } catch (e2) { /* never block checkout */ }
    }
    // Keep the button locked — we're leaving the page.
    window.location.href = mmCheckoutUrl();
  } catch (e) {
    showCartError('A network error occurred. Please check your connection and try again.');
    restore();
  }
}

/* ----------------------------------------------------------
   10a. PRODUCT FORM (real <form action="/cart/add">)
   ---------------------------------------------------------- */
function lockSubmit(form) {
  if (form.__mmLocked) return false;
  form.__mmLocked = true;
  var btn = form.querySelector('button[type="submit"], [data-mm-action="atc"]');
  if (btn) {
    btn.dataset.mmOrigText = btn.dataset.mmOrigText || (btn.querySelector('.mm-btn__label') ? btn.querySelector('.mm-btn__label').textContent : btn.textContent);
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    var labelEl = btn.querySelector('.mm-btn__label') || btn;
    labelEl.textContent = 'Adding…';
  }
  return true;
}
function unlockSubmit(form) {
  form.__mmLocked = false;
  var btn = form.querySelector('button[type="submit"], [data-mm-action="atc"]');
  if (btn) {
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    if (btn.dataset.mmOrigText) {
      var labelEl = btn.querySelector('.mm-btn__label') || btn;
      labelEl.textContent = btn.dataset.mmOrigText;
    }
  }
}

/* Best-effort line data for the drawer's optimistic pending row: the currently
   selected variant from the buybox's variants JSON, falling back to the
   form's product-level data attributes (set in pdp-hero.liquid). */
function mmAtcPendingInfo(form) {
  var title = form.dataset.mmProductTitle || 'Item';
  var image = form.dataset.mmProductImage || '';
  var price = parseInt(form.dataset.mmProductPrice, 10) || 0;
  var idInput = form.querySelector('[data-mm-variant-id]');
  var vid = idInput ? parseInt(idInput.value, 10) || 0 : 0;
  var jsonScript = form.querySelector('[data-mm-variants-json]');
  if (vid && jsonScript) {
    try {
      var variants = JSON.parse(jsonScript.textContent) || [];
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id !== vid) continue;
        if (typeof variants[i].price === 'number') price = variants[i].price;
        if (variants[i].featured_image && variants[i].featured_image.src) {
          var src = variants[i].featured_image.src;
          image = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=144';
        }
        break;
      }
    } catch (e) { /* fall back to the form-level data */ }
  }
  // The offer box's FREE rows are the visible promise of what this click
  // adds — mirror them into the stand-in so the drawer shows the whole
  // setup the same frame, gifts included. The /cart.js reconcile swaps in
  // the real line titles/images once the add lands.
  var gifts = [];
  var offer = form.querySelector('.mm-offer');
  if (offer) {
    offer.querySelectorAll('.mm-offer__item').forEach(function (row) {
      var nowEl = row.querySelector('.mm-offer__item-now');
      if (!nowEl || !/free/i.test(nowEl.textContent)) return; // paid row = the product itself
      var nameEl = row.querySelector('.mm-offer__item-name');
      var img = row.querySelector('img');
      var wasEl = row.querySelector('.mm-offer__item-was');
      gifts.push({
        title: nameEl ? nameEl.textContent.trim() : 'Free gift',
        image: img ? img.getAttribute('src') : '',
        was: wasEl ? wasEl.textContent.trim() : ''
      });
    });
  }
  return { id: vid || 'atc', title: title, image: image, price: price, gifts: gifts };
}

/* The whole ATC sequence, optimistic-first: the drawer opens with a pending
   line the same frame the customer clicks — the two network round trips
   (/cart/add.js, then the /cart.js reconcile) that used to hold the drawer
   shut for ~1s now run behind it. Failures surface inside the OPEN drawer,
   so a rejected add can never look like a dead click again. */
function handleAtcSubmit(form) {
  if (!lockSubmit(form)) return; // already in flight — ignore rage-clicks
  var bundleMode = form.dataset.mmBundleMode;
  var kitVariants = form.dataset.mmKitVariants;

  // Everything before the fetch is guarded: the submit's default action is
  // already prevented by our listener, so an exception past this point would
  // otherwise mean NO request, no error UI, and a form locked on "Adding…"
  // forever — a silently dead buy button. The optimistic chrome (pending
  // row, drawer) is cosmetic; only the fetch below must always be reached.
  var info = { id: 'atc', title: 'Item', image: '', price: 0 };
  try {
    info = mmAtcPendingInfo(form);
    clearCartError();
    // Optimism window: renderItems keeps this stand-in painted until the
    // paid line is confirmed server-side (see mmReassertPendingSetup).
    mmPendingSetup = { info: info, until: Date.now() + 12000, recovered: false };
    insertPendingLine(info);
    openCart();
  } catch (e) { /* cosmetic only — the add below still runs */ }

  var addPromise;
  try {
    if (bundleMode === 'kit' && kitVariants) {
      // Kit mode: multi-add via items[]
      var ids = String(kitVariants).split(',').map(function(id) { return id.trim(); }).filter(Boolean);
      addPromise = mmTrackAdd(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function(id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
      }));
    } else {
      // Authoritative purchase-mode reconcile before we read the fields.
      // The native radio is the source of truth — it toggles even when an
      // app re-render wiped our selection listeners — so this guarantees a
      // "one-time" choice never posts `selling_plan` (no surprise
      // subscription) and "subscribe" posts the currently shown plan.
      form.querySelectorAll('[data-mm-sub]').forEach(function(group) {
        mmApplySubMode(group, mmSubMode(group));
      });
      var fdAtc = new FormData(form);
      mmKachingPlanFailsafe(form, fdAtc);
      addPromise = mmTrackAdd(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fdAtc
      }));
    }
  } catch (e) {
    // Prep failed (e.g. an app re-render mid-click) — post the raw form
    // as-is rather than stranding the customer with a dead button.
    try {
      addPromise = mmTrackAdd(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      }));
    } catch (e2) {
      mmPendingSetup = null;
      removePendingLine(info.id);
      showCartError('Could not add item to cart. Please try again.');
      unlockSubmit(form);
      return;
    }
  }

  addPromise
    .then(function(res) {
      if (!res.ok) {
        return res.json().catch(function() { return {}; }).then(function(err) {
          throw new Error(err.description || 'Could not add item to cart. Please try again.');
        });
      }
      // The refetch re-renders the list; the stand-in stays painted until
      // the paid line is confirmed, then the watchdog stands down.
      return CartState.fetch().then(clearCartError).then(function() { mmEnsureSetupLanded(0); });
    })
    .catch(function(err) {
      mmPendingSetup = null;
      removePendingLine(info.id);
      showCartError((err && err.message) || 'A network error occurred. Please check your connection and try again.');
      // Reconcile empty state / totals from server truth.
      CartState.fetch();
    })
    .then(function() { unlockSubmit(form); });
}

function initProductForms() {
  document.querySelectorAll('[data-mm-product-form]').forEach(function(form) {
    // Marks the node as having a live submit listener. Apps (Kaching etc.)
    // sometimes re-render the buybox and replace the form node — the clone
    // loses this flag along with the listener, and the document-level backup
    // click handler below takes over. See initWidgetLift for prior art on
    // app re-renders wiping per-node listeners.
    form.__mmWired = true;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      handleAtcSubmit(form);
    });
  });
}

/* Backup path for the "first click did nothing" failure: if the click's form
   is not wired (node replaced after boot), run the handler directly. Wired
   forms fall through to their own submit event so nothing runs twice. */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('button[type="submit"], [data-mm-action="atc"]');
  if (!btn) return;
  var form = btn.form || btn.closest('form');
  if (!form || !form.hasAttribute('data-mm-product-form')) return;
  if (form.__mmWired) return;
  e.preventDefault();
  handleAtcSubmit(form);
});

/* ----------------------------------------------------------
   10b. VARIANT PICKER — match selected options to a variant
   ---------------------------------------------------------- */
function initVariantPickers() {
  document.querySelectorAll('[data-mm-product-form]').forEach(function(form) {
    var jsonScript = form.querySelector('[data-mm-variants-json]');
    var hiddenId = form.querySelector('[data-mm-variant-id]');
    if (!jsonScript || !hiddenId) return;

    var variants;
    try { variants = JSON.parse(jsonScript.textContent); } catch (e) { return; }

    var optionInputs = Array.from(form.querySelectorAll('[data-mm-option-input]'));
    if (!optionInputs.length) return;

    // Variant-value → image-override map (built from <variant_image> blocks)
    var imageOverrides = [];
    var overridesScript = form.querySelector('[data-mm-variant-image-overrides]');
    if (overridesScript) {
      try { imageOverrides = JSON.parse(overridesScript.textContent) || []; } catch (e) { imageOverrides = []; }
    }
    // Cache original src so we can revert when the merchant doesn't define an override for the selected value
    var imageTargets = Array.from(form.querySelectorAll('[data-mm-variant-image-target]'));
    imageTargets.forEach(function(img) {
      if (!img.dataset.mmVariantImageOriginal) img.dataset.mmVariantImageOriginal = img.getAttribute('src') || '';
    });

    function currentSelection() {
      var groups = {};
      optionInputs.forEach(function(input) {
        // Selects always contribute their value; radios only when checked.
        if (input.tagName !== 'SELECT' && !input.checked) return;
        var i = input.dataset.mmOptionInput;
        groups[i] = input.value;
      });
      // Build ordered array based on option index
      var keys = Object.keys(groups).sort(function(a,b){ return parseInt(a,10) - parseInt(b,10); });
      return keys.map(function(k) { return groups[k]; });
    }

    function variantOpts(v) {
      if (Array.isArray(v.options)) return v.options;
      return [v.option1, v.option2, v.option3].filter(function(x){ return x != null; });
    }

    function update(isInit) {
      var sel = currentSelection();
      var match = variants.find(function(v) {
        var vo = variantOpts(v);
        return vo.length === sel.length && vo.every(function(opt, i) { return opt === sel[i]; });
      });
      if (!match) return;

      hiddenId.value = match.id;
      // Tell the page (hero gallery slide 1, …) — not on the priming call,
      // so the default variant leaves the merchant's slide order alone.
      if (!isInit) {
        document.dispatchEvent(new CustomEvent('mm:variant:change', {
          detail: { id: match.id, options: variantOpts(match), image: (match.featured_image && match.featured_image.src) || null, source: 'theme' }
        }));
      }

      // Update displayed option labels
      form.querySelectorAll('[data-mm-option-display]').forEach(function(el) {
        var idx = parseInt(el.dataset.mmOptionDisplay, 10);
        if (sel[idx] != null) el.textContent = sel[idx];
      });

      // Update price + sticky atc price if the price changed
      var priceEls = document.querySelectorAll('[data-mm-live-price], .mm-offer__price, .mm-sticky-atc__price');
      if (match.price != null) {
        priceEls.forEach(function(el) { el.textContent = formatMoney(match.price); });
      }
      var wasEls = document.querySelectorAll('.mm-offer__was');
      if (match.compare_at_price && match.compare_at_price > match.price) {
        wasEls.forEach(function(el) { el.textContent = formatMoney(match.compare_at_price); el.hidden = false; });
      } else {
        wasEls.forEach(function(el) { el.hidden = true; });
      }

      // Variant-image override — match any selected option value against the merchant's overrides
      if (imageOverrides.length && imageTargets.length) {
        var overrideSrc = null;
        for (var i = 0; i < sel.length && !overrideSrc; i++) {
          var found = imageOverrides.find(function(o) { return o.value === sel[i]; });
          if (found) overrideSrc = found.src;
        }
        imageTargets.forEach(function(img) {
          var newSrc = overrideSrc || img.dataset.mmVariantImageOriginal;
          if (newSrc && img.getAttribute('src') !== newSrc) img.setAttribute('src', newSrc);
        });
      }
    }

    optionInputs.forEach(function(input) { input.addEventListener('change', function () { update(false); }); });
    update(true);
  });
}

/* ----------------------------------------------------------
   10c. UPSELL QUICK-ADD
   ---------------------------------------------------------- */
async function applyPromoCode() {
  var input = document.querySelector('[data-mm-promo-input]');
  var msg   = document.querySelector('[data-mm-promo-msg]');
  if (!input || !input.value.trim()) return;
  var code = input.value.trim();
  if (msg) { msg.hidden = true; msg.removeAttribute('data-state'); }
  try {
    // Shopify natively applies discounts via /discount/<code> redirect.
    // Persist to a cart attribute so it survives drawer navigation.
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'discount_code': code } })
    });
    if (msg) {
      msg.textContent = 'Code saved — applied at checkout.';
      msg.removeAttribute('data-state');
      msg.hidden = false;
    }
  } catch (e) {
    if (msg) {
      msg.textContent = 'Could not apply code. Please try again.';
      msg.setAttribute('data-state', 'error');
      msg.hidden = false;
    }
  }
}

/* Stand-in cart row so an added item appears in the list the instant it is
   requested — before /cart/add.js returns. renderItems() clears every
   .mm-cart__item before re-inserting, so the stand-in removes itself as soon
   as the real /cart.js line arrives. info: { id, title, image, price, free }
   — free: true paints the threshold gift's row (pill, no qty, FREE). */
function insertPendingLine(info) {
  var container = document.getElementById('mm-cart-items');
  if (!container) return;
  var title = info.title || 'Item';
  var price = info.price || 0;
  // A second add before the server reconciles bumps the stand-in's quantity
  // instead of stacking a duplicate row (both adds still reach the server,
  // which merges them into one line).
  var pending = container.querySelector('.mm-cart__item[data-key="pending-' + info.id + '"]');
  if (pending) {
    var pendingQty = pending.querySelector('.mm-cart__qty-val');
    if (pendingQty) pendingQty.textContent = (parseInt(pendingQty.textContent, 10) || 1) + 1;
    return;
  }
  var media = info.image
    ? '<img class="mm-cart__item-img" src="' + info.image + '" alt="' + escapeHtml(title) + '" width="72" height="72" loading="lazy">'
    : '<div class="mm-cart__item-img mm-ph" data-label="ITEM"></div>';
  // Free gifts render in the exact markup renderBundleGifts uses for the
  // real lines, so the stand-in → server swap is visually seamless.
  var giftsHtml = '';
  if (info.gifts && info.gifts.length) {
    var glabel = info.gifts.length === 1 ? 'Your free gift' : 'Your ' + info.gifts.length + ' free gifts';
    giftsHtml = '<ul class="mm-cart__gifts" role="list">' +
      '<li class="mm-cart__gifts-label" aria-hidden="true">' + glabel + '</li>' +
      info.gifts.map(function (g) {
        var gmedia = g.image
          ? '<img class="mm-cart__gift-img" src="' + g.image + '" alt="" width="32" height="32" loading="lazy">'
          : '<span class="mm-cart__gift-img mm-cart__gift-img--ph" aria-hidden="true"></span>';
        return '<li class="mm-cart__gift">' +
            gmedia +
            '<span class="mm-cart__gift-meta"><span class="mm-cart__gift-name">' + escapeHtml(g.title) + '</span></span>' +
            '<span class="mm-cart__gift-price">' +
              (g.was ? '<span class="mm-cart__gift-was">' + escapeHtml(g.was) + '</span>' : '') +
              '<span class="mm-cart__gift-free">Free</span>' +
            '</span>' +
          '</li>';
      }).join('') +
    '</ul>';
  }
  var html = '<div class="mm-cart__item mm-cart__item--pending' + (info.free ? ' mm-cart__item--gift' : '') + '" data-key="pending-' + info.id + '">' +
    media +
    '<div class="mm-cart__item-meta">' +
      '<div class="mm-cart__item-name">' + escapeHtml(title) + '</div>' +
      (info.free ? '<div class="mm-cart__item-pill">Free gift</div>' : '') +
      '<div class="mm-cart__item-foot">' +
        (info.free
          ? ''
          : '<div class="mm-cart__item-qty" role="group" aria-label="Quantity">' +
              '<span class="mm-cart__qty-val">1</span>' +
            '</div>') +
        '<div class="mm-cart__item-pricing">' +
          (info.free
            ? '<div class="mm-cart__item-price"><span class="mm-cart__item-now mm-cart__item-now--free">Free</span></div>'
            : '<div class="mm-cart__item-price">' + formatMoney(price) + '</div>') +
        '</div>' +
      '</div>' +
    '</div>' +
    giftsHtml +
  '</div>';
  var empty = document.getElementById('mm-cart-empty');
  if (empty) empty.hidden = true;
  container.insertAdjacentHTML('afterbegin', html);
  // Optimistic money: bump the visible total and progress bars now; the
  // /cart.js reconcile overwrites them with server truth moments later.
  var optimistic = CartState.subtotal + price;
  var footer = document.getElementById('mm-cart-footer');
  if (footer) footer.hidden = false;
  var subtotalEl = document.getElementById('mm-cart-subtotal');
  mmPaintCartTotal(subtotalEl, optimistic);
  patchShippingBarOptimistic(optimistic);
  patchGiftBarOptimistic(optimistic);
  GiftReward.patchOptimistic(optimistic);
}

function removePendingLine(id) {
  var row = document.querySelector('.mm-cart__item[data-key="pending-' + id + '"]');
  if (row) row.remove();
}

/* Optimistic quick-add: the UI confirms instantly — "✓ Added" on the button
   and the line appearing in the cart — while the network request runs behind
   it and /cart.js reconciles the real state. No spinners, no waiting. */
function quickAddToCart(button) {
  // Re-entry guard: the 1.6s "✓ Added" state doubles as the lockout window.
  if (button.dataset.mmBusy === '1') return;
  var id = button.dataset.variant;
  if (!id) return;
  var idNum = parseInt(id, 10);

  // Capture original label exactly once and stash on the element so repeated
  // clicks during the "Added" state can't overwrite it.
  if (!button.dataset.mmOrigLabel) {
    button.dataset.mmOrigLabel = button.textContent.trim();
  }
  var orig = button.dataset.mmOrigLabel;

  button.dataset.mmBusy = '1';
  button.setAttribute('data-added', '');
  button.textContent = '✓ Added';
  var restore = function(errState) {
    button.textContent = orig;
    button.dataset.mmBusy = '';
    button.removeAttribute('data-added');
    if (errState) {
      button.setAttribute('data-error', '');
      button.textContent = 'Error';
      setTimeout(function() {
        button.removeAttribute('data-error');
        button.textContent = orig;
      }, 1500);
    }
  };
  setTimeout(function() {
    if (button.dataset.mmBusy === '1') restore(false);
  }, 1600);

  // If this variant is already in the cart, bump its quantity instead of
  // letting Shopify create a second card. We merge even into lines with
  // tracking properties (e.g. __kaching_bundles) — those mark the same
  // product, not an add-on. Add-on lines like shipping protection live on
  // a different variant so the variant_id check alone keeps us out of them.
  // Subscription lines are the one exception: never bump a selling-plan
  // line from a one-time upsell add.
  var existing = null;
  for (var i = 0; i < CartState.items.length; i++) {
    var it = CartState.items[i];
    if (it.variant_id !== idNum) continue;
    if (it.selling_plan_allocation) continue;
    existing = it;
    break;
  }

  if (existing) {
    // The qty pipeline is already fully optimistic (instant DOM patch,
    // debounced /cart/change.js flush, /cart.js reconcile).
    updateCartQty(existing.key, 1);
    return;
  }

  insertPendingLine({
    id: idNum,
    title: button.dataset.title,
    image: button.dataset.image,
    price: parseInt(button.dataset.price, 10) || 0
  });
  mmTrackAdd(fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: idNum, quantity: 1 })
  }))
    .then(function(res) {
      if (!res.ok) throw new Error('add failed');
      // The refetch re-renders the list, replacing the stand-in row.
      return CartState.fetch();
    })
    .catch(function() {
      removePendingLine(idNum);
      restore(true);
      showCartError('Couldn’t add that item — please try again.');
      // Reconcile empty state / totals from server truth.
      CartState.fetch();
    });
}

/* The add-on card renders the variant's Liquid price, but app / automatic
   discounts only exist on cart lines. Once the variant is in the cart, its
   discount-aware unit price is authoritative — mirror it onto the card so the
   add-on never advertises more than the cart actually charges, and strike the
   base price through as the markdown anchor. */
function syncAddonPricesFromCart() {
  document.querySelectorAll('[data-mm-addon-price]').forEach(function(el) {
    var vid = parseInt(el.dataset.variant, 10);
    var base = parseInt(el.dataset.base, 10) || 0;
    var line = null;
    for (var i = 0; i < CartState.items.length; i++) {
      var it = CartState.items[i];
      if (it.variant_id !== vid || it.selling_plan_allocation) continue;
      line = it;
      break;
    }
    if (!line || !line.quantity) return;
    var unit = (typeof line.final_line_price === 'number')
      ? Math.round(line.final_line_price / line.quantity)
      : line.price;
    if (!(unit > 0) || unit >= base) return;
    var now = el.querySelector('.mm-cart__addon-now');
    if (now) now.textContent = formatMoney(unit);
    if (!el.querySelector('.mm-cart__addon-was')) {
      el.insertAdjacentHTML('beforeend', '<s class="mm-cart__addon-was">' + formatMoney(base) + '</s>');
    }
  });
}
document.addEventListener('mm:cart:updated', syncAddonPricesFromCart);

/* ----------------------------------------------------------
   ADD-ON PEEK — product popup from the cart add-ons carousel
   ----------------------------------------------------------
   Clicking an add-on card opens one reusable shell (#mm-addon-peek) filled
   from the clicked card, so every product works with zero per-product setup:

     card dataset → title, price, link, Add button payload (instant)
     {url}.js     → the gallery images, in PDP order (~4KB, lands first)
     {url}        → the product page, whose .mm-buybox__bullet nodes ARE the
                    Benefit Bullet blocks from that product's hero buybox

   Benefit bullets are section-block settings inside each product's own
   template, which Liquid in the drawer cannot reach and the Section Rendering
   API cannot serve — ?section_id= needs the template-scoped id
   (template--<id>__hero), which is unknowable from here. Parsing the page is
   the only source of truth, so it's paid once per product: prefetched on
   hover/touch, kept in memory, and mirrored into sessionStorage so the rest
   of the session is free.

   The popup paints from the dataset in the same frame as the click and swaps
   the fetched gallery and bullets in when they land — nothing waits on the
   network. A product with no bullets on its page (e.g. one on the default
   product template) simply shows images and no bullet list. */
var AddonPeek = {
  cache: {},      // product url → in-flight or settled Promise<{images,bullets}>
  card: null,     // the card the open popup belongs to
  open: false,
  lastFocus: null,
  hideTimer: null,
  trap: null
};

function peekWidth(src, w) {
  if (!src) return src;
  return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 900);
}

/* The page is parsed, never injected — only textContent crosses over, so a
   product title or bullet can't smuggle markup into the drawer. DOMParser
   builds an inert document, so none of the page's own images or scripts load. */
function parseHeroBullets(html) {
  var out = [];
  if (!html) return out;
  try {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nodes = doc.querySelectorAll('.mm-buybox__bullet');
    for (var i = 0; i < nodes.length && out.length < 6; i++) {
      var node = nodes[i].cloneNode(true);
      // Drop the icon first: built-in icons are <svg>, but Google Material
      // Symbols render as a <span> whose text is the ligature name ("check"),
      // which would otherwise land in the copy.
      node.querySelectorAll('svg, .mm-icon--google').forEach(function(icon) { icon.remove(); });
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      // A hero can render the buybox twice (mobile + desktop); keep one of each.
      if (text && out.indexOf(text) === -1) out.push(text);
    }
  } catch (err) { /* malformed section HTML — fall through with what we have */ }
  return out;
}

function parseDescriptionBullets(html) {
  var out = [];
  if (!html) return out;
  try {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var items = doc.querySelectorAll('li');
    for (var i = 0; i < items.length && out.length < 6; i++) {
      var text = (items[i].textContent || '').replace(/\s+/g, ' ').trim();
      // Long prose in a description list reads as a paragraph, not a benefit.
      if (text && text.length <= 90 && out.indexOf(text) === -1) out.push(text);
    }
  } catch (err) { /* malformed description — fall through */ }
  return out;
}

/* v2: entries gained `offers` (Kaching deals parsed off the product page) —
   the bump invalidates v1 sessions that would otherwise never show them. */
var PEEK_STORE_KEY = 'mm-addon-peek-v2';

/* The target product's own Kaching Bundles deals, read from the same fetched
   PDP HTML the bullets come from. Kaching server-renders its deal config as
   JSON script tags into the page, and DOMParser documents are inert, so the
   JSON is readable without running any of the page's scripts. Same math as
   mmKachingDeal() above, but listing every bar — these are the "offers" the
   popup surfaces. They only apply through the product's own PDP widget
   (Kaching skips plain cart adds), so they render as informational rows, not
   as the popup's price. */
function parsePeekOffers(html) {
  var out = [];
  if (!html) return out;
  try {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var prodEl = doc.querySelector('.kaching-bundles-product[data-main="true"]') ||
                 doc.querySelector('.kaching-bundles-product');
    if (!prodEl) return out;
    var dealEl = doc.querySelector(
      '.kaching-bundles-deal-block-settings[data-product-id="' + prodEl.getAttribute('data-product-id') + '"]'
    ) || doc.querySelector('.kaching-bundles-deal-block-settings');
    if (!dealEl) return out;

    var prod = JSON.parse(prodEl.textContent);
    var cfg = JSON.parse(dealEl.textContent);

    var unit = 0;
    var variants = prod.variants || [];
    for (var j = 0; j < variants.length; j++) {
      if (variants[j].id === prod.selectedVariantId) { unit = variants[j].price; break; }
    }
    if (!unit && variants.length) unit = variants[0].price;
    if (!unit) return out;

    (cfg.dealBars || []).forEach(function(bar) {
      var qty = bar.quantity || 1;
      var orig = unit * qty;
      var save = 0;
      if (bar.discountType === 'specific') {
        save = orig - Math.round(bar.discountValue * 100); // discountValue = deal price in dollars
      } else if (bar.discountType === 'percentage') {
        save = Math.round(orig * bar.discountValue / 100);
      } else if (bar.discountType === 'amount' || bar.discountType === 'fixed') {
        save = Math.round(bar.discountValue * 100);
      }
      if (save <= 0 || save >= orig) return;
      var title = (typeof bar.title === 'string' && bar.title) ||
                  (typeof bar.name === 'string' && bar.name) ||
                  ('Buy ' + qty);
      out.push({ title: title, qty: qty, price: orig - save, orig: orig, save: save });
    });
  } catch (err) { /* no Kaching on that page — nothing to offer */ }
  return out.slice(0, 4);
}

function readPeekStore() {
  try { return JSON.parse(sessionStorage.getItem(PEEK_STORE_KEY)) || {}; }
  catch (err) { return {}; }
}

function writePeekStore(url, data) {
  try {
    var all = readPeekStore();
    all[url] = data;
    sessionStorage.setItem(PEEK_STORE_KEY, JSON.stringify(all));
  } catch (err) { /* private mode / quota — the in-memory cache still holds */ }
}

function fetchPeekData(url) {
  if (AddonPeek.cache[url]) return AddonPeek.cache[url];

  var stored = readPeekStore()[url];
  if (stored) {
    AddonPeek.cache[url] = Promise.resolve(stored);
    return AddonPeek.cache[url];
  }

  var images = fetch(url + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function(res) { return res.ok ? res.json() : null; })
    .catch(function() { return null; });
  var page = fetch(url, { headers: { 'Accept': 'text/html' } })
    .then(function(res) { return res.ok ? res.text() : ''; })
    .catch(function() { return ''; });

  // Cache the promise, not the result: two fast clicks share one round trip.
  AddonPeek.cache[url] = Promise.all([images, page]).then(function(res) {
    var product = res[0] || {};
    // Products on the default product template have no hero buybox to read;
    // their description's list items are the next-best benefit copy, and cost
    // nothing extra — the description rides along in the .js payload.
    var bullets = parseHeroBullets(res[1]);
    if (!bullets.length) bullets = parseDescriptionBullets(product.description);
    // Compare-at per variant, so the popup can strike a markdown through even
    // when the card was rendered before one was set.
    var compare = {};
    (product.variants || []).forEach(function(v) {
      if (v && v.compare_at_price > v.price) compare[v.id] = v.compare_at_price;
    });
    var data = {
      images: (product.images || []).slice(0, 8).map(function(src) { return peekWidth(src); }),
      bullets: bullets,
      compare: compare,
      offers: parsePeekOffers(res[1])
    };
    // Only worth storing if the trip actually produced something.
    if (data.images.length || data.bullets.length || data.offers.length) writePeekStore(url, data);
    return data;
  });
  return AddonPeek.cache[url];
}

function renderPeekMedia(images, fallback) {
  var el = document.getElementById('mm-addon-peek');
  if (!el) return;
  var track = el.querySelector('[data-mm-apk-track]');
  var dotsEl = el.querySelector('[data-mm-apk-dots]');
  if (!track) return;
  var list = (images && images.length) ? images : (fallback ? [fallback] : []);

  track.innerHTML = '';
  list.forEach(function(src, i) {
    var img = document.createElement('img');
    img.className = 'mm-apk__img';
    img.src = src;
    img.alt = '';
    img.loading = i === 0 ? 'eager' : 'lazy';
    img.decoding = 'async';
    track.appendChild(img);
  });
  track.scrollLeft = 0;

  if (!dotsEl) return;
  dotsEl.innerHTML = '';
  if (list.length < 2) return;
  list.forEach(function(_, i) {
    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'mm-apk__dot';
    dot.dataset.i = i;
    dot.setAttribute('aria-label', 'Image ' + (i + 1));
    if (i === 0) dot.setAttribute('data-active', '');
    dotsEl.appendChild(dot);
  });
}

/* What the shopper would actually be charged for one of these right now.
   A live cart line is the only client-side source that knows about app and
   automatic discounts (Kaching deals included), so once the variant is in the
   cart its discount-aware unit price wins over the Liquid price. */
function peekUnitPrice(variantId, base) {
  for (var i = 0; i < CartState.items.length; i++) {
    var it = CartState.items[i];
    if (it.variant_id !== variantId || it.selling_plan_allocation) continue;
    if (!it.quantity) break;
    var unit = (typeof it.final_line_price === 'number')
      ? Math.round(it.final_line_price / it.quantity)
      : it.price;
    if (unit > 0 && unit < base) return unit;
    break;
  }
  return base;
}

/* Price row: what it costs now, the original struck through, and how much
   that saves. The "was" anchor is the retail compare-at when the product has
   one, and otherwise the Liquid price — which only differs from `now` when a
   cart discount is doing the work. No markdown, no strikethrough. */
function renderPeekPrice(card, fetchedCompare) {
  var el = document.getElementById('mm-addon-peek');
  if (!el) return;
  var wrap = el.querySelector('[data-mm-apk-price]');
  if (!wrap) return;

  var base = parseInt(card.dataset.price, 10) || 0;
  var now = peekUnitPrice(parseInt(card.dataset.variant, 10), base);
  var compare = parseInt(card.dataset.compare, 10) || fetchedCompare || 0;

  var was = 0;
  if (compare > now) was = compare;
  else if (now < base) was = base;

  wrap.innerHTML = '';
  var nowEl = document.createElement('span');
  nowEl.className = 'mm-apk__now';
  nowEl.textContent = formatMoney(now);
  wrap.appendChild(nowEl);

  if (was <= now) return;

  var wasEl = document.createElement('s');
  wasEl.className = 'mm-apk__was';
  wasEl.textContent = formatMoney(was);
  wrap.appendChild(wasEl);

  // Below ~5% the badge reads as noise next to the strikethrough.
  var pct = Math.round((was - now) / was * 100);
  if (pct < 5) return;
  var saveEl = document.createElement('span');
  saveEl.className = 'mm-apk__save';
  saveEl.textContent = 'Save ' + pct + '%';
  wrap.appendChild(saveEl);
}

function renderPeekBullets(bullets) {
  var el = document.getElementById('mm-addon-peek');
  if (!el) return;
  var list = el.querySelector('[data-mm-apk-bullets]');
  if (!list) return;
  list.innerHTML = '';
  if (!bullets || !bullets.length) return;
  bullets.forEach(function(text) {
    var li = document.createElement('li');
    li.className = 'mm-apk__bullet';
    li.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      '<polyline points="20 6 9 17 4 12"/></svg><span></span>';
    li.querySelector('span').textContent = text;
    list.appendChild(li);
  });
}

/* The product's own Kaching offers as informational rows under the price.
   The container is created on first use so the shell markup (which predates
   offers) needs no edit; styles live in pdp-product-carousel's stylesheet.
   Only textContent is ever written — deal titles come from app JSON and
   must not be able to inject markup. */
function renderPeekOffers(offers) {
  var el = document.getElementById('mm-addon-peek');
  if (!el) return;
  var wrap = el.querySelector('[data-mm-apk-offers]');
  if (!wrap) {
    var price = el.querySelector('[data-mm-apk-price]');
    if (!price) return;
    wrap = document.createElement('div');
    wrap.className = 'mm-apk__offers';
    wrap.setAttribute('data-mm-apk-offers', '');
    price.insertAdjacentElement('afterend', wrap);
  }
  wrap.innerHTML = '';
  if (!offers || !offers.length) { wrap.hidden = true; return; }
  wrap.hidden = false;

  var head = document.createElement('div');
  head.className = 'mm-apk__offers-h';
  head.textContent = 'Bundle & save';
  wrap.appendChild(head);

  offers.forEach(function(o) {
    var row = document.createElement('div');
    row.className = 'mm-apk__offer';
    row.innerHTML = '<span class="mm-apk__offer-name"></span>' +
      '<span class="mm-apk__offer-price"></span>' +
      '<s class="mm-apk__offer-was"></s>' +
      '<span class="mm-apk__offer-save"></span>';
    row.querySelector('.mm-apk__offer-name').textContent = o.title;
    row.querySelector('.mm-apk__offer-price').textContent = formatMoney(o.price);
    row.querySelector('.mm-apk__offer-was').textContent = formatMoney(o.orig);
    row.querySelector('.mm-apk__offer-save').textContent =
      'Save ' + Math.round(o.save * 100 / o.orig) + '%';
    wrap.appendChild(row);
  });
}

/* Opening the popup is a product view Klaviyo would otherwise never see —
   the shopper reads the gallery and bullets without visiting the PDP. Feed
   the onsite pixel the standard Viewed Product pair so browse-abandonment
   flows and recently-viewed blocks keep working. The Klaviyo app owns the
   queue object; no-op when it isn't installed. */
function mmPeekTrackKlaviyo(card) {
  try {
    var kl = window.klaviyo || window._learnq;
    if (!kl || typeof kl.push !== 'function') return;
    var price = (parseInt(card.dataset.price, 10) || 0) / 100;
    var url = card.dataset.url ? (location.origin + card.dataset.url) : location.href;
    var item = {
      Name: card.dataset.title || '',
      ProductID: card.dataset.variant || '',
      URL: url,
      ImageURL: card.dataset.image || '',
      Price: price
    };
    kl.push(['track', 'Viewed Product', item]);
    kl.push(['trackViewedItem', {
      Title: item.Name,
      ItemId: item.ProductID,
      Url: item.URL,
      ImageUrl: item.ImageURL,
      Metadata: { Price: price }
    }]);
  } catch (err) { /* tracking must never break the popup */ }
}

function openAddonPeek(card) {
  var el = document.getElementById('mm-addon-peek');
  if (!el || !card) return;
  bindPeekShell(el);
  if (AddonPeek.hideTimer) { clearTimeout(AddonPeek.hideTimer); AddonPeek.hideTimer = null; }

  AddonPeek.card = card;
  var url = card.dataset.url || '';
  var title = card.dataset.title || '';

  var titleEl = el.querySelector('[data-mm-apk-title]');
  if (titleEl) titleEl.textContent = title;

  renderPeekPrice(card, 0);

  var link = el.querySelector('[data-mm-apk-link]');
  if (link) link.href = url || '#';

  // Hand the Add button the same payload the card's own Add button carries so
  // it rides the existing optimistic quick-add pipeline untouched.
  var add = el.querySelector('[data-mm-apk-add]');
  if (add) {
    add.dataset.variant = card.dataset.variant || '';
    add.dataset.title = title;
    add.dataset.price = card.dataset.price || '0';
    if (card.dataset.thumb) add.dataset.image = card.dataset.thumb;
    else delete add.dataset.image;
    // Clear any "✓ Added" / error state left over from the last product.
    add.dataset.mmBusy = '';
    add.removeAttribute('data-added');
    add.removeAttribute('data-error');
    if (add.dataset.mmOrigLabel) add.textContent = add.dataset.mmOrigLabel;
  }

  // Paint from what we already have so the popup is on screen this frame.
  renderPeekMedia([], card.dataset.image);
  renderPeekBullets([]);
  renderPeekOffers([]);
  el.setAttribute('data-loading', '');

  mmPeekTrackKlaviyo(card);

  AddonPeek.lastFocus = document.activeElement;
  el.hidden = false;
  el.setAttribute('aria-hidden', 'false');
  requestAnimationFrame(function() { el.setAttribute('data-open', ''); });
  AddonPeek.open = true;
  lockBodyScroll('peek');
  trapPeekFocus(el);
  requestAnimationFrame(function() {
    var x = el.querySelector('[data-mm-apk-close]');
    if (x && x.focus) x.focus();
  });

  if (!url) { el.removeAttribute('data-loading'); return; }
  fetchPeekData(url).then(function(data) {
    // Bail if it was closed, or another card was opened, while we waited.
    if (!AddonPeek.open || AddonPeek.card !== card) return;
    el.removeAttribute('data-loading');
    renderPeekMedia(data.images, card.dataset.image);
    renderPeekBullets(data.bullets);
    renderPeekOffers(data.offers);
    renderPeekPrice(card, (data.compare && data.compare[card.dataset.variant]) || 0);
  }).catch(function() { el.removeAttribute('data-loading'); });
}

function closeAddonPeek() {
  var el = document.getElementById('mm-addon-peek');
  if (!el || !AddonPeek.open) return;
  AddonPeek.open = false;
  AddonPeek.card = null;
  el.removeAttribute('data-open');
  el.setAttribute('aria-hidden', 'true');
  releasePeekFocus(el);
  unlockBodyScroll('peek');
  // Hide only after the fade so the panel doesn't vanish mid-transition.
  AddonPeek.hideTimer = setTimeout(function() {
    el.hidden = true;
    AddonPeek.hideTimer = null;
  }, 180);
  if (AddonPeek.lastFocus && AddonPeek.lastFocus.focus) AddonPeek.lastFocus.focus();
  AddonPeek.lastFocus = null;
}

/* Self-contained focus trap. The shared trapFocus() keeps its handler in one
   module-level variable, so reusing it here would orphan the drawer's trap
   underneath us. */
function trapPeekFocus(el) {
  releasePeekFocus(el);
  AddonPeek.trap = function(e) {
    if (e.key !== 'Tab') return;
    var f = el.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };
  el.addEventListener('keydown', AddonPeek.trap);
}

function releasePeekFocus(el) {
  if (!AddonPeek.trap) return;
  el.removeEventListener('keydown', AddonPeek.trap);
  AddonPeek.trap = null;
}

/* Wired on first open, not at boot, and guarded per element — the theme
   editor re-renders the whole drawer section on every settings change, which
   would otherwise strand these listeners on a detached shell. */
function bindPeekShell(el) {
  if (el.__mmPeekBound) return;
  el.__mmPeekBound = true;

  var track = el.querySelector('[data-mm-apk-track]');
  var dotsEl = el.querySelector('[data-mm-apk-dots]');
  if (!track || !dotsEl) return;

  var ticking = false;
  track.addEventListener('scroll', function() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      ticking = false;
      var dots = dotsEl.children;
      if (dots.length < 2 || !track.clientWidth) return;
      var idx = Math.min(dots.length - 1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth)));
      for (var i = 0; i < dots.length; i++) {
        if (i === idx) dots[i].setAttribute('data-active', '');
        else dots[i].removeAttribute('data-active');
      }
    });
  }, { passive: true });

  dotsEl.addEventListener('click', function(e) {
    var dot = e.target.closest('.mm-apk__dot');
    if (!dot) return;
    track.scrollTo({ left: parseInt(dot.dataset.i, 10) * track.clientWidth, behavior: 'smooth' });
  });
}

/* Close is delegated from the document for the same reason. */
document.addEventListener('click', function(e) {
  if (!AddonPeek.open || !e.target.closest) return;
  if (!e.target.closest('[data-mm-apk-close]')) return;
  e.preventDefault();
  closeAddonPeek();
});

function initAddonPeek() {
  // Warm the cache on intent, so the gallery and bullets are usually already
  // in hand by the time the popup opens. Selector covers every peek trigger:
  // cart add-on cards and the PDP product-carousel cards alike.
  document.querySelectorAll('[data-mm-action="addon-peek"][data-url]').forEach(function(card) {
    var warm = function() { fetchPeekData(card.dataset.url); };
    card.addEventListener('pointerenter', warm, { once: true });
    card.addEventListener('touchstart', warm, { once: true, passive: true });
  });
}

function showCartError(msg) {
  var el = document.getElementById('mm-cart-error');
  if (el) {
    el.textContent = msg;
    el.hidden = false;
    // The error line lives inside the footer, which is hidden while the cart
    // is empty — a failed FIRST add would otherwise report to a hidden node
    // and look like the click never registered.
    var footer = document.getElementById('mm-cart-footer');
    if (footer) footer.hidden = false;
  }
}

function clearCartError() {
  var el = document.getElementById('mm-cart-error');
  if (el) { el.textContent = ''; el.hidden = true; }
}

var __mmQtyPending = Object.create(null); // key -> { target, timer, inflight, item }

function patchLineDom(key, qty) {
  var row = document.querySelector('.mm-cart__item[data-key="' + key + '"]');
  if (!row) return;
  var qv = row.querySelector('.mm-cart__qty-val');
  if (qv) qv.textContent = qty;

  var item = CartState.items.find(function (i) { return i.key === key; });
  if (item) {
    // Use the discount-aware per-unit so optimistic line totals match
    // what the server will return after line-level discounts.
    var unitNow = (item.quantity > 0 && typeof item.final_line_price === 'number')
      ? (item.final_line_price / item.quantity)
      : item.price;
    var unitWas = 0;
    if (item.original_line_price && item.quantity && item.original_line_price / item.quantity > unitNow) {
      unitWas = item.original_line_price / item.quantity;
    }
    if (!unitWas) unitWas = getItemWasUnit(item);

    var nowEl = row.querySelector('.mm-cart__item-now');
    var wasEl = row.querySelector('.mm-cart__item-was');
    var saveEl = row.querySelector('.mm-cart__item-save');
    var single = row.querySelector('.mm-cart__item-price');
    var nowTotal = unitNow * qty;
    var wasTotal = unitWas * qty;

    if (nowEl) nowEl.textContent = formatMoney(nowTotal);
    if (wasEl && unitWas) wasEl.textContent = formatMoney(wasTotal);
    if (saveEl && unitWas) {
      var drawerForMode = document.getElementById('mm-cart');
      saveEl.textContent = mmSaveBadgeText(wasTotal - nowTotal, wasTotal, (drawerForMode && drawerForMode.dataset.savingsMode) || 'strikethrough');
    }
    if (!nowEl && single && !single.querySelector('span')) {
      single.textContent = formatMoney(nowTotal);
    }
  }

  if (qty <= 0) {
    row.style.transition = 'opacity .18s ease';
    row.style.opacity = '0.4';
    row.style.pointerEvents = 'none';
  } else {
    row.style.opacity = '';
    row.style.pointerEvents = '';
  }
}

function patchSubtotalDom() {
  // Discount-aware optimistic subtotal: prefer the per-unit price
  // *after* line-level discounts (final_line_price / quantity) so the
  // displayed total matches what the server will return.
  var total = CartState.items.reduce(function (sum, it) {
    var pendingTarget = __mmQtyPending[it.key] ? __mmQtyPending[it.key].target : it.quantity;
    var unit = (it.quantity > 0 && typeof it.final_line_price === 'number')
      ? (it.final_line_price / it.quantity)
      : it.price;
    return sum + unit * pendingTarget;
  }, 0);
  var subtotalEl = document.getElementById('mm-cart-subtotal');
  mmPaintCartTotal(subtotalEl, total);
  renderCartSavings(CartState.items, function (it) {
    return __mmQtyPending[it.key] ? __mmQtyPending[it.key].target : it.quantity;
  });
  // Drive shipping + gift bars off the same optimistic subtotal so
  // they animate in lockstep with each click instead of lagging the
  // server round-trip.
  patchShippingBarOptimistic(total);
  patchGiftBarOptimistic(total);
  GiftReward.patchOptimistic(total);
}

function patchShippingBarOptimistic(subtotal) {
  var bar = document.getElementById('mm-cart-ship');
  if (bar && !bar.hidden) {
    var threshold = parseInt(bar.dataset.threshold, 10) || 0;
    if (threshold) {
      var remaining = Math.max(0, threshold - subtotal);
      var pct = Math.min(100, (subtotal / threshold) * 100);
      var fill = bar.querySelector('[data-mm-ship-fill]');
      var msg  = bar.querySelector('[data-mm-ship-msg]');
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        var tplProgress = bar.dataset.textProgress || 'You’re {amount} away from free shipping';
        var tplUnlocked = bar.dataset.textUnlocked || '🎉 You unlocked <strong>free shipping</strong>!';
        var amount = '<strong>' + formatMoney(remaining) + '</strong>';
        msg.innerHTML = remaining === 0 ? tplUnlocked : tplProgress.replace(/\{amount\}/g, amount);
      }
    }
  }
}

/* Top-panel free-gift row (#mm-cart-gift): fill, marker state and message for
   a subtotal — shared by the server-truth path (updateGiftBar) and the
   optimistic one (patchGiftBarOptimistic). The marker (the circle holding the
   gift image) sits at data-marker-pos % of the track; the fill is scaled so it
   meets the marker exactly at the threshold, then runs to the end once
   unlocked. data-near flags the last quarter of the climb so the marker can
   nudge ("almost there"). Templates are merchant copy and may carry <strong>
   (same contract as the shipping bar); the gift name — a product title or the
   label field — is escaped before it goes in. */
function mmGiftBarPaint(bar, subtotal) {
  var threshold = parseInt(bar.dataset.threshold, 10) || 0;
  if (!threshold) return;
  var label = bar.dataset.label || 'free gift';
  var pos = parseFloat(bar.dataset.markerPos);
  if (!(pos > 0)) pos = 100;
  var remaining = Math.max(0, threshold - subtotal);
  var progress = Math.min(1, Math.max(0, subtotal / threshold));
  var unlocked = remaining === 0;
  var fill = bar.querySelector('[data-mm-gift-fill]');
  var msg  = bar.querySelector('[data-mm-gift-msg]');
  if (fill) fill.style.width = (unlocked ? 100 : progress * pos) + '%';
  if (msg) {
    var tpl = unlocked
      ? (bar.dataset.textUnlocked || '🎁 You unlocked your {gift}!')
      : (bar.dataset.textProgress || 'Add {amount} to unlock your {gift}');
    msg.innerHTML = tpl
      .replace(/\{amount\}/g, '<strong>' + formatMoney(remaining) + '</strong>')
      .replace(/\{gift\}/g, '<strong>' + escapeHtml(label) + '</strong>');
  }
  if (unlocked) bar.setAttribute('data-unlocked', ''); else bar.removeAttribute('data-unlocked');
  if (!unlocked && progress >= 0.75) bar.setAttribute('data-near', ''); else bar.removeAttribute('data-near');
}

function patchGiftBarOptimistic(subtotal) {
  var bar = document.getElementById('mm-cart-gift');
  if (!bar || bar.hidden) return;
  mmGiftBarPaint(bar, subtotal);
}

/* ----------------------------------------------------------
   FREE GIFT REWARD — threshold card under the line items
   ----------------------------------------------------------
   #mm-cart-reward is rendered by pdp-cart-drawer.liquid off the drawer
   section's gift_reward_* settings; everything that moves lives here.

   Qualifying total = cart total_price minus the gift line itself, so the
   gift can never help unlock itself. (A gift zeroed by an automatic
   discount contributes $0 anyway; a misconfigured full-price one would
   otherwise pad the total.)

   States, in precedence order:
     hidden    cart empty (unless editor-pinned), or the gift variant is
               already a cart line — that line (Free gift pill + FREE) is
               the confirmation, so the card gets out of the way.
     progress  under the threshold: "Add $X more…", bar at N%.
     unlocked  at/over it with no gift in the cart: auto-add fires once
               (data-auto-add) or the Add button shows.

   Adds tag their line with the _mm_free_gift property so it can be found
   again: that's the line auto-removal takes back out when the cart drops
   under — never a copy the shopper bought outright. A shopper who removes
   the gift while still qualified has declined — remembered for the session
   and reset the moment the cart falls under, so the next climb offers it
   again. A failed auto-add falls back to the button instead of retrying in
   a loop.
   ---------------------------------------------------------- */
var GiftReward = {
  PROP: '_mm_free_gift',
  STORE: 'mm_gift_reward_dismissed',
  busy: false,
  autoFailed: false,

  el: function () { return document.getElementById('mm-cart-reward'); },
  variantId: function (el) { return parseInt(el.dataset.variant, 10) || 0; },

  // The line WE added (carries the marker) — the only one removal touches.
  giftLine: function (items) {
    var el = this.el();
    if (!el) return null;
    var vid = this.variantId(el);
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it.variant_id === vid && it.properties && it.properties[this.PROP]) return it;
    }
    return null;
  },

  // Any line of the gift variant — ours or one the shopper bought outright.
  inCart: function (items, vid) {
    for (var i = 0; i < items.length; i++) if (items[i].variant_id === vid) return true;
    return false;
  },

  dismissed: function () {
    try { return sessionStorage.getItem(this.STORE) === '1'; } catch (e) { return false; }
  },
  setDismissed: function (on) {
    try {
      if (on) sessionStorage.setItem(this.STORE, '1');
      else sessionStorage.removeItem(this.STORE);
    } catch (e) { /* storage blocked — the flag just won't persist */ }
  },

  // From the cart-qty click handler: taking OUR gift line to 0 is the
  // shopper declining it, not a cart that fell under the threshold.
  noteManualChange: function (key, delta) {
    var g = this.giftLine(CartState.items);
    if (g && g.key === key && g.quantity + delta <= 0) this.setDismissed(true);
  },

  // Fill + message for a qualifying total; returns whether it's unlocked.
  // Templates are merchant copy from the section settings and may carry
  // <strong> — same contract as the shipping bar, so innerHTML on purpose.
  paint: function (el, qualifying) {
    var threshold = parseInt(el.dataset.threshold, 10) || 0;
    if (!threshold) return true;
    var remaining = Math.max(0, threshold - qualifying);
    var pct = Math.min(100, (qualifying / threshold) * 100);
    var fill = el.querySelector('[data-mm-reward-fill]');
    var msg  = el.querySelector('[data-mm-reward-msg]');
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      var tplProgress = el.dataset.textProgress || 'Add {amount} more to unlock your free gift';
      var tplUnlocked = el.dataset.textUnlocked || 'You unlocked your free gift';
      msg.innerHTML = remaining === 0
        ? '🎉 ' + tplUnlocked
        : tplProgress.replace(/\{amount\}/g, '<strong>' + formatMoney(remaining) + '</strong>');
    }
    if (remaining === 0) el.setAttribute('data-unlocked', '');
    else el.removeAttribute('data-unlocked');
    return remaining === 0;
  },

  // Server truth — runs after every /cart.js fetch.
  update: function () {
    var el = this.el();
    if (!el) return;
    if (CartState.emptyAndNotPinned()) { el.hidden = true; return; }
    var items = CartState.items;
    var vid = this.variantId(el);
    var g = this.giftLine(items);
    var qualifying = Math.max(0, CartState.subtotal - (g ? mmLineTotal(g) : 0));
    var unlocked = this.paint(el, qualifying);
    var addBtn = el.querySelector('.mm-cart__reward-add');
    var autoAdd = el.dataset.autoAdd === 'true';

    if (!unlocked) {
      // Back under: the offer is live again, and a gift we put in the cart
      // comes back out — whichever way it got there (auto or the button).
      this.setDismissed(false);
      this.autoFailed = false;
      if (g && !this.busy) this.remove(g);
      if (addBtn) addBtn.hidden = true;
      el.hidden = false;
      return;
    }

    if (this.inCart(items, vid)) { el.hidden = true; return; }

    if (autoAdd && items.length && !this.dismissed() && !this.autoFailed && !this.busy && !mmAddInFlight) {
      // The stand-in line insertPendingLine paints is the confirmation, so
      // the card steps aside now rather than flashing "unlocked" first.
      el.hidden = true;
      this.add(el, null);
      return;
    }
    if (addBtn) addBtn.hidden = false;
    el.hidden = false;
  },

  // Optimistic — runs off the same provisional total the subtotal and the
  // shipping bar use, so the fill moves with each click instead of lagging
  // the round-trip. Display only; adding/removing waits for server truth.
  patchOptimistic: function (total) {
    var el = this.el();
    if (!el || el.hidden) return;
    var g = this.giftLine(CartState.items);
    var giftPart = 0;
    if (g) {
      var target = __mmQtyPending[g.key] ? __mmQtyPending[g.key].target : g.quantity;
      var unit = g.quantity > 0 ? mmLineTotal(g) / g.quantity : g.price;
      giftPart = unit * target;
    }
    this.paint(el, Math.max(0, total - giftPart));
  },

  add: function (el, btn) {
    var self = this;
    var vid = this.variantId(el);
    if (!vid || this.busy) return;
    this.busy = true;
    if (btn) btn.setAttribute('data-busy', '');
    insertPendingLine({ id: vid, title: el.dataset.title || 'Free gift', image: el.dataset.image, price: 0, free: true });
    var props = {};
    props[this.PROP] = '1';
    mmTrackAdd(fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1, properties: props })
    }))
      .then(function (res) {
        if (!res.ok) throw new Error('gift add failed');
        self.busy = false;
        if (btn) btn.removeAttribute('data-busy');
        return CartState.fetch();
      })
      .catch(function () {
        self.busy = false;
        self.autoFailed = true; // fall back to the button — never loop
        removePendingLine(vid);
        if (btn) {
          btn.removeAttribute('data-busy');
          btn.setAttribute('data-error', '');
          var orig = btn.textContent;
          btn.textContent = 'Couldn’t add — try again';
          setTimeout(function () { btn.removeAttribute('data-error'); btn.textContent = orig; }, 1800);
        }
        CartState.fetch();
      });
  },

  remove: function (g) {
    var self = this;
    this.busy = true;
    patchLineDom(g.key, 0); // dims the row now; the reconcile drops it
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: g.key, quantity: 0 })
    })
      .catch(function () { /* the refetch reconciles either way */ })
      .then(function () { self.busy = false; return CartState.fetch(); });
  }
};

async function flushQty(key) {
  var p = __mmQtyPending[key];
  if (!p) return;
  if (p.inflight) return; // a sync is already running; it will re-flush after
  p.inflight = true;
  // Capture exactly what we're sending. If we compared the post-fetch
  // server quantity to p.target afterwards, an inventory cap would loop
  // forever (target=10, server caps to 5 → re-flush 10 → cap 5 → …).
  // Re-flush only when the *user's* target moved while we were in-flight.
  var sent = p.target;
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: sent })
    });
  } catch (e) { /* network error — refetch will reconcile */ }
  await CartState.fetch();
  var stillPending = __mmQtyPending[key];
  if (stillPending) {
    if (stillPending.target !== sent) {
      stillPending.inflight = false;
      flushQty(key);
      return;
    }
    delete __mmQtyPending[key];
  }
}

function updateCartQty(key, delta) {
  var item = CartState.items.find(function (i) { return i.key === key; });
  if (!item) return;
  var p = __mmQtyPending[key];
  if (!p) {
    p = __mmQtyPending[key] = { target: item.quantity, timer: 0, inflight: false, item: item };
  }
  p.target = Math.max(0, p.target + delta);
  patchLineDom(key, p.target);
  patchSubtotalDom();
  clearTimeout(p.timer);
  p.timer = setTimeout(function () { flushQty(key); }, 220);
}

// Cart drawer purchase-type pill: moves a line onto a selling plan (planId)
// or back to one-time (planId null) in one shot — a discrete click, not a
// stepper, so no debounce. Mirrors flushQty()'s /cart/change.js call. The
// highlight flips at once for feel; CartState.fetch() then reconciles the real
// result, so a change Shopify rejects (e.g. a plan sold out on that cadence)
// simply re-renders the line as it really is.
function switchLinePurchase(key, planId, btn) {
  var item = CartState.items.find(function (i) { return i.key === key; });
  if (!item) return;
  var pill = btn.closest('.mm-cart__pill');
  if (pill) {
    if (pill.hasAttribute('data-busy')) return;
    pill.setAttribute('data-busy', '');
    pill.querySelectorAll('.mm-cart__pill-opt').forEach(function (o) {
      var on = o === btn;
      o.classList.toggle('is-on', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: item.quantity, selling_plan: planId })
  })
    .catch(function () { /* refetch reconciles either way */ })
    .then(function () { return CartState.fetch(); });
}

/* ----------------------------------------------------------
   11. NEWSLETTER
   ---------------------------------------------------------- */
function initNewsletter() {
  document.querySelectorAll('[data-action="newsletter-subscribe"]').forEach(function(form) {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.value) return;

      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = '…'; btn.disabled = true; }

      var klaviyoListId = window.MM_KLAVIYO_LIST_ID;

      try {
        if (klaviyoListId) {
          await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + klaviyoListId, {
            method: 'POST',
            headers: { 'content-type': 'application/json', revision: '2023-02-22' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: {
              list_id: klaviyoListId,
              email: emailInput.value
            }}})
          });
        } else {
          var fd = new FormData();
          fd.append('form_type', 'customer');
          fd.append('utf8', '✓');
          fd.append('contact[email]', emailInput.value);
          await fetch('/contact', { method: 'POST', body: fd });
        }
        if (btn) { btn.textContent = '✓ Joined'; }
        emailInput.value = '';
      } catch (err) {
        if (btn) { btn.textContent = 'Error — try again'; }
      } finally {
        setTimeout(function() {
          if (btn) { btn.textContent = original; btn.disabled = false; }
        }, 3000);
      }
    });
  });
}

/* ----------------------------------------------------------
   12. EVENT DELEGATION — central click handler
   ---------------------------------------------------------- */
document.addEventListener('click', function(e) {
  var action = e.target.closest('[data-mm-action]');
  if (!action) return;

  var type = action.dataset.mmAction;

  switch (type) {
    case 'open-cart':
      e.preventDefault();
      /* open instantly with the last known cart; the /cart.js refresh
         re-renders the list when it lands instead of gating the slide-in */
      openCart();
      CartState.fetch();
      break;

    case 'close-cart':
      closeCart();
      break;

    case 'open-drawer':
      openDrawer();
      break;

    case 'close-drawer':
      closeDrawer();
      break;

    case 'add-to-cart':
      // If button is a submit inside a product form, let the form handler take it
      if (action.tagName === 'BUTTON' && action.type === 'submit') {
        break;
      }
      e.preventDefault();
      if (action.__mmLocked) break; // ignore rage-clicks
      action.__mmLocked = true;
      action.disabled = true;
      action.setAttribute('aria-busy', 'true');
      var origLabelEl = action.querySelector('.mm-btn__label') || action;
      var origText = origLabelEl.textContent;
      origLabelEl.textContent = 'Adding…';
      Promise.resolve(addToCart(action.dataset.variants || action.dataset.variant)).finally(function () {
        action.__mmLocked = false;
        action.disabled = false;
        action.removeAttribute('aria-busy');
        origLabelEl.textContent = origText;
      });
      break;

    case 'buy-now':
      e.preventDefault();
      var bnForm = action.closest('[data-mm-product-form]');
      if (bnForm) buyNow(bnForm, action);
      break;

    case 'quick-add':
      e.preventDefault();
      quickAddToCart(action);
      // Added from the peek popup: hold the "✓ Added" state briefly so the
      // click is acknowledged, then close onto the cart with the new line
      // already in it (the add is optimistic, so it's there immediately).
      // A failed add stays put instead, so the shopper sees the Error state
      // on the button they actually pressed.
      if (action.hasAttribute('data-mm-apk-add')) {
        setTimeout(function() {
          if (!action.hasAttribute('data-error')) closeAddonPeek();
        }, 550);
      }
      break;

    case 'addon-peek':
      e.preventDefault();
      openAddonPeek(action);
      break;

    case 'apply-promo':
      e.preventDefault();
      applyPromoCode();
      break;

    case 'checkout':
      e.preventDefault();
      mmGoCheckout(action);
      break;

    case 'cart-purchase':
      e.preventDefault();
      if (action.getAttribute('aria-checked') === 'true') break;
      switchLinePurchase(action.dataset.key, action.dataset.mode === 'plan' ? action.dataset.plan : null, action);
      break;

    case 'cart-qty':
      e.preventDefault();
      var key = action.dataset.key;
      var delta = parseInt(action.dataset.delta, 10);
      GiftReward.noteManualChange(key, delta);
      updateCartQty(key, delta);
      break;

    case 'reward-add':
      e.preventDefault();
      var rewardEl = document.getElementById('mm-cart-reward');
      if (rewardEl) {
        GiftReward.setDismissed(false);
        GiftReward.autoFailed = false;
        GiftReward.add(rewardEl, action);
      }
      break;

    case 'reviews-page':
      /* Decorative pagination — extend here for async load */
      var allPageBtns = document.querySelectorAll('[data-mm-action="reviews-page"]');
      allPageBtns.forEach(function(btn) { btn.removeAttribute('aria-current'); });
      action.setAttribute('aria-current', 'true');
      break;

    case 'search':
      /* Delegate to Shopify's native search or predictive search */
      if (typeof window.Shopify !== 'undefined' && Shopify.routes) {
        window.location.href = Shopify.routes.search_url || '/search';
      }
      break;
  }
});

/* Scrim clicks close the relevant panel */
document.addEventListener('click', function(e) {
  if (e.target.matches('[data-mm-cart-scrim]')) closeCart();
  if (e.target.matches('[data-mm-drawer-scrim]')) closeDrawer();
});

/* Escape key closes open panels */
document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape') return;
  // The peek popup sits on top of the drawer, so it closes first.
  if (AddonPeek.open) closeAddonPeek();
  else if (cartDrawerOpen) closeCart();
  else if (navDrawerOpen) closeDrawer();
});

/* ----------------------------------------------------------
   13. INIT
   ---------------------------------------------------------- */
/* ----------------------------------------------------------
   STICKY HEADER (scroll-aware)
   ---------------------------------------------------------- */
function initStickyHeader() {
  var header = document.getElementById('mm-site-header');
  if (!header) return;
  var mode = header.dataset.mmSticky;
  if (mode !== 'scroll') return; // CSS handles "always" and "never" via [data-mm-sticky] selectors

  var lastY = window.scrollY;
  var DELTA = 8;       // ignore scroll noise smaller than this
  var TOP_BUFFER = 80; // never hide while still near the top
  var ticking = false;

  function update() {
    var y = window.scrollY;
    var diff = y - lastY;
    if (Math.abs(diff) < DELTA) { ticking = false; return; }
    if (y < TOP_BUFFER) {
      header.classList.remove('is-hidden');
    } else if (diff > 0) {
      header.classList.add('is-hidden');     // scrolling down → hide
    } else {
      header.classList.remove('is-hidden');  // scrolling up → show
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
}

/* ----------------------------------------------------------
   Theme-editor integration — click a section or block in the
   editor sidebar and the corresponding drawer (cart or mobile
   nav) slides into view automatically. No effect on the live
   storefront.
   ---------------------------------------------------------- */
function initEditorDrawerHooks() {
  // Only run inside the Shopify theme editor preview iframe
  if (!(window.Shopify && Shopify.designMode)) return;

  // Heuristics to map a selected section/block to the right drawer.
  // We open the cart drawer for anything whose id/type/path mentions
  // cart/upsell/shipping/promo/checkout, and the nav drawer for
  // mobile-drawer/menu hits.
  var cartHints   = /cart|upsell|shipping|gift|promo|checkout/i;
  var navHints    = /drawer|hamburger|nav/i;
  var stickyHints = /sticky|hero|buybox|atc/i;

  function probe(detail) {
    if (!detail) return '';
    return [detail.sectionId, detail.blockId, detail.type, detail.id, detail.path].join(' ');
  }

  function pick(detail) {
    var s = probe(detail);
    if (cartHints.test(s))   return 'cart';
    if (navHints.test(s))    return 'nav';
    if (stickyHints.test(s)) return 'sticky';
    // Fall through: also inspect the actual selected DOM element if present
    var el = document.querySelector('[data-shopify-editor-block-selected],[data-shopify-editor-section-selected]');
    if (el && el.closest && el.closest('#mm-cart'))        return 'cart';
    if (el && el.closest && el.closest('#mm-drawer'))      return 'nav';
    if (el && el.closest && el.closest('#mm-sticky-atc'))  return 'sticky';
    return '';
  }

  function showSticky() {
    var bar = document.getElementById('mm-sticky-atc');
    if (bar) bar.setAttribute('data-visible', '');
  }
  function hideSticky() {
    var bar = document.getElementById('mm-sticky-atc');
    if (bar && !bar.hasAttribute('data-editor-pinned') &&
        bar.getAttribute('data-mm-trigger') !== 'always') bar.removeAttribute('data-visible');
  }

  function handleSelect(e) {
    var which = pick(e.detail);
    if (which === 'cart'   && typeof openCart   === 'function') openCart();
    if (which === 'nav'    && typeof openDrawer === 'function') openDrawer();
    if (which === 'sticky') showSticky();
  }

  function handleDeselect() {
    if (typeof closeCart   === 'function') closeCart();
    if (typeof closeDrawer === 'function') closeDrawer();
    hideSticky();
  }

  document.addEventListener('shopify:section:select', handleSelect);
  document.addEventListener('shopify:block:select',   handleSelect);
  document.addEventListener('shopify:section:deselect', handleDeselect);
  document.addEventListener('shopify:block:deselect',   handleDeselect);
}

/* ----------------------------------------------------------
   10b2. KACHING SUBSCRIPTIONS — one-time row is an instant ATC.
   The theme CSS demotes the widget's "One time purchase" card to a
   centered text link under the subscription card. Clicking it no
   longer switches the widget's plan selection — it adds the current
   variant to the cart as a one-time line (no selling plan) and the
   drawer opens as the click feedback (addToCart does both).
   Capture phase so the widget's own select handler never runs; the
   subscription card stays the selected option in the buybox.
   ---------------------------------------------------------- */
document.addEventListener('click', function (e) {
  if (!e.target || !e.target.closest) return;
  var row = e.target.closest('kaching-subscriptions .kaching-subscriptions__card-wrapper.one-time-purchase');
  if (!row) return;
  e.preventDefault();
  e.stopPropagation();

  // Rage-click lockout — addToCart has no re-entry guard of its own.
  if (row.__mmBusy) return;
  row.__mmBusy = true;
  setTimeout(function () { row.__mmBusy = false; }, 1200);

  // Current variant: the widget renders inside the native product form;
  // fall back to any product form on the page (single-form PDPs).
  var form = row.closest('form[action*="/cart/add"]');
  var idInput = (form && form.querySelector('input[name="id"], select[name="id"]')) ||
                document.querySelector('[data-mm-product-form] input[name="id"], form[action*="/cart/add"] input[name="id"]');
  var vid = idInput && idInput.value;
  if (!vid) return;
  addToCart(vid);
}, true);

/* ----------------------------------------------------------
   10c. SUBSCRIPTION WIDGET — radio cards + frequency select.
   Toggles hidden line-item-property inputs (disabled = not posted).

   Listeners are DELEGATED on `document` rather than bound to each card.
   The cards live inside the product form, which subscription/bundle apps
   (Kaching, etc.) re-render after we boot — that wiped per-card listeners,
   so clicking "One-Time" only toggled the native radio while the gold
   `is-selected` styling and the `selling_plan` disable never ran. The card
   visually stayed on "Subscribe" and a subscription was still posted to the
   cart. Delegation re-resolves the DOM at event time, so it survives those
   re-renders; the form submit handler additionally reconciles from the
   native radio as a final guard (see initProductForms).
   ---------------------------------------------------------- */
// Matches Shopify-formatted money strings ($29.99, £1,299.00, etc.)
var MM_SUB_MONEY_RE = /([$€£¥₹]|kr|CHF|₩|CAD|USD)\s?[\d,]+(?:\.\d+)?/;

function mmSyncSubAtc(priceText) {
  if (!priceText) return;
  document.querySelectorAll('[data-mm-action="add-to-cart"] .mm-btn__label').forEach(function(el) {
    var t = el.textContent;
    if (MM_SUB_MONEY_RE.test(t)) {
      // Function replacement — a plain string like "$116.99" would be parsed
      // as the "$1" backreference (the captured currency symbol) + "16.99",
      // turning $116.99 into $16.99.
      el.textContent = t.replace(MM_SUB_MONEY_RE, function () { return priceText; });
    } else if (t.indexOf('—') === -1) {
      el.textContent = t.trim() + ' — ' + priceText;
    }
  });
  document.querySelectorAll('.mm-sticky-atc__price').forEach(function(el) {
    el.textContent = priceText;
  });
}

function mmRenderSubTokens(tpl, vals) {
  if (!tpl) return '';
  return tpl
    .replace(/\{discount\}/g, vals.discount || '')
    .replace(/\{percent\}/g,  vals.percent  || '')
    .replace(/\{price\}/g,    vals.price    || '')
    .replace(/\{was\}/g,      vals.was      || '')
    .replace(/\{saved\}/g,    vals.saved    || '');
}

// Purchase mode for a group, derived from the checked native radio (reliable
// even if our JS was wiped — clicking the label still checks it), with the
// server default as fallback.
function mmSubMode(group) {
  var checked = group.querySelector('input[name="mm-sub-choice"]:checked');
  if (checked) return checked.value;
  return (group.getAttribute('data-mm-sub-default') === 'onetime') ? 'onetime' : 'subscribe';
}

// Authoritatively apply a purchase mode ('subscribe' | 'onetime') to a widget.
// Re-queries the group every call so it works after app-driven DOM re-renders.
function mmApplySubMode(group, mode) {
  if (!group) return;
  var planEl  = group.querySelector('[data-mm-sub-plan-input]');
  var propOne = group.querySelector('[data-mm-sub-prop="onetime"]');
  var propSub = group.querySelector('[data-mm-sub-prop="subscribe"]');
  var freqSel = group.querySelector('[data-mm-sub-freq-select]');
  var priceEl = group.querySelector('[data-mm-sub-disc-price]');
  var oneCardPriceEl = group.querySelector('[data-mm-sub-card="onetime"] .mm-sub__price');

  group.querySelectorAll('[data-mm-sub-card]').forEach(function(c) {
    var match = c.getAttribute('data-mm-sub-card') === mode;
    c.classList.toggle('is-selected', match);
    var radio = c.querySelector('.mm-sub__radio-input');
    if (radio) radio.checked = match;
  });

  if (planEl)  planEl.disabled  = (mode !== 'subscribe');
  if (propOne) propOne.disabled = (mode !== 'onetime');
  if (propSub) propSub.disabled = (mode !== 'subscribe');

  // Keep the posted selling_plan aligned with the visible frequency choice,
  // so the right plan ships even if the freq listener was re-rendered away.
  if (mode === 'subscribe' && planEl && freqSel &&
      group.getAttribute('data-mm-sub-has-plans') === '1' && freqSel.value) {
    planEl.value = freqSel.value;
  }

  var price = (mode === 'subscribe' && priceEl) ? priceEl.textContent.trim()
            : (mode === 'onetime'  && oneCardPriceEl) ? oneCardPriceEl.textContent.trim()
            : null;
  mmSyncSubAtc(price);
}

// Apply a frequency-select change: update the plan id, price + token strings.
function mmApplySubFreq(group, freqSel) {
  var opt = freqSel.options[freqSel.selectedIndex];
  if (!opt) return;
  var hasPlans = group.getAttribute('data-mm-sub-has-plans') === '1';
  var planEl   = group.querySelector('[data-mm-sub-plan-input]');
  var priceEl  = group.querySelector('[data-mm-sub-disc-price]');
  if (hasPlans && planEl) planEl.value = opt.value; // selling_plan ID
  var price = opt.getAttribute('data-price');
  var pct   = opt.getAttribute('data-pct');
  var vals = {
    discount: opt.getAttribute('data-discount') || (pct ? pct + '%' : ''),
    percent:  pct,
    price:    price,
    was:      opt.getAttribute('data-was'),
    saved:    opt.getAttribute('data-saved')
  };
  if (price && priceEl) priceEl.textContent = price;
  group.querySelectorAll('[data-mm-sub-tpl]').forEach(function(el) {
    el.textContent = mmRenderSubTokens(el.getAttribute('data-mm-sub-tpl'), vals);
  });
  // If subscribe is currently selected, push the new price to the ATC bar.
  if (group.querySelector('[data-mm-sub-card="subscribe"].is-selected') && price) mmSyncSubAtc(price);
}

function initSubscriptionWidgets() {
  // Initial per-group sync — server rendered ATC with the base variant price;
  // reflect the default selection's price now.
  document.querySelectorAll('[data-mm-sub]').forEach(function(group) {
    mmApplySubMode(group, mmSubMode(group));
  });

  // Delegated change: native radio toggles (incl. label clicks + keyboard)
  // and frequency-select changes both bubble here.
  document.addEventListener('change', function(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var radio = t.closest('input[name="mm-sub-choice"]');
    if (radio) {
      var g = radio.closest('[data-mm-sub]');
      if (g) mmApplySubMode(g, radio.value);
      return;
    }
    var freq = t.closest('[data-mm-sub-freq-select]');
    if (freq) {
      var gf = freq.closest('[data-mm-sub]');
      if (gf) mmApplySubFreq(gf, freq);
    }
  });

  // Delegated click: covers re-selecting a card whose native radio is already
  // checked, and any case where label→radio forwarding was suppressed.
  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.mm-sub__freq-select')) return;
    var card = e.target.closest('[data-mm-sub-card]');
    if (!card) return;
    var g = card.closest('[data-mm-sub]');
    if (g) mmApplySubMode(g, card.getAttribute('data-mm-sub-card'));
  });

  // Delegated keyboard: the cards are <label>s (tabindex=0) which don't
  // natively respond to Space/Enter; let the wrapped radio handle its own keys.
  document.addEventListener('keydown', function(e) {
    if (e.key !== ' ' && e.key !== 'Enter') return;
    if (!e.target || !e.target.closest) return;
    if (e.target.matches('input, select, textarea, button, a')) return;
    var card = e.target.closest('[data-mm-sub-card]');
    if (!card) return;
    e.preventDefault();
    var g = card.closest('[data-mm-sub]');
    if (g) mmApplySubMode(g, card.getAttribute('data-mm-sub-card'));
  });
}

/* ----------------------------------------------------------
   11b. SUBSCRIPTION INFO SHEET — dark bottom sheet
   Triggered by the ⓘ link and the secondary "details" link.
   ---------------------------------------------------------- */
function initSubSheet() {
  var openers = document.querySelectorAll('[data-mm-sheet-open]');
  if (!openers.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastFocus = null;

  function openSheet(sheet) {
    if (!sheet || !sheet.hidden) return;
    lastFocus = document.activeElement;
    sheet.hidden = false;
    document.body.style.overflow = 'hidden';
    void sheet.offsetWidth; // force reflow so the transition runs
    sheet.classList.add('is-open');
    var closeBtn = sheet.querySelector('.mm-sheet__x');
    if (closeBtn) closeBtn.focus();
  }

  function finishClose(sheet) {
    sheet.hidden = true;
    var panel = sheet.querySelector('.mm-sheet__panel');
    if (panel) panel.style.transform = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    lastFocus = null;
  }

  function closeSheet(sheet, fromDrag) {
    if (!sheet || sheet.hidden) return;
    document.body.style.overflow = '';
    var panel = sheet.querySelector('.mm-sheet__panel');

    if (reduceMotion || !panel) {
      sheet.classList.remove('is-open');
      finishClose(sheet);
      return;
    }

    var done = function() {
      panel.removeEventListener('transitionend', done);
      sheet.classList.remove('is-open');
      finishClose(sheet);
    };
    panel.addEventListener('transitionend', done);
    setTimeout(done, 420); // safety net if transitionend never fires

    if (fromDrag) {
      // Continue the slide from wherever the finger left it
      panel.style.transform = 'translateY(100%)';
    } else {
      sheet.classList.remove('is-open');
    }
  }

  // Open triggers
  openers.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var sheet = document.getElementById(btn.getAttribute('data-mm-sheet-open'));
      openSheet(sheet);
    });
  });

  document.querySelectorAll('[data-mm-sheet]').forEach(function(sheet) {
    // Close affordances: X button + scrim
    sheet.querySelectorAll('[data-mm-sheet-close]').forEach(function(el) {
      el.addEventListener('click', function() { closeSheet(sheet, false); });
    });

    // Esc to close
    sheet.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSheet(sheet, false);
    });

    // Sticky ATC inside the sheet always commits the subscription
    var sheetAtc = sheet.querySelector('[data-mm-sheet-atc]');
    if (sheetAtc) {
      sheetAtc.addEventListener('click', function() {
        var group = sheet.closest('[data-mm-sub]');
        var subCard = group && group.querySelector('[data-mm-sub-card="subscribe"]');
        if (subCard) subCard.click(); // select subscribe before the form submits
        closeSheet(sheet, false);
        // No preventDefault — the submit proceeds and opens the cart drawer
      });
    }

    // Drag-to-dismiss on the grip (mobile)
    var grip = sheet.querySelector('[data-mm-sheet-grip]');
    var panel = sheet.querySelector('.mm-sheet__panel');
    if (grip && panel) {
      var startY = 0, dy = 0, dragging = false;
      grip.addEventListener('pointerdown', function(e) {
        dragging = true; startY = e.clientY; dy = 0;
        panel.style.transition = 'none';
        grip.setPointerCapture(e.pointerId);
      });
      grip.addEventListener('pointermove', function(e) {
        if (!dragging) return;
        dy = Math.max(0, e.clientY - startY);
        panel.style.transform = 'translateY(' + dy + 'px)';
      });
      var endDrag = function() {
        if (!dragging) return;
        dragging = false;
        panel.style.transition = '';
        if (dy > 110) {
          closeSheet(sheet, true);
        } else {
          panel.style.transform = ''; // snap back
        }
      };
      grip.addEventListener('pointerup', endDrag);
      grip.addEventListener('pointercancel', endDrag);
    }
  });
}

/* ----------------------------------------------------------
   GUARANTEE BADGE — sizes the badge column beside the title.
   Width = main-column height × image aspect ratio (capped). The CSS
   aspect-ratio fallback resolves to 0 width in some flex passes
   (intrinsic sizing runs before the stretched height is definite),
   so the measured width is set explicitly here. Runs twice per pass:
   the first width can re-wrap the title, the second converges.
   ---------------------------------------------------------- */
function mmSizeGuaranteeBadges() {
  var rows = document.querySelectorAll('.mm-buybox__gbadge-row');
  if (!rows.length) return;
  var pass = function () {
    rows.forEach(function (row) {
      var badge = row.querySelector('.mm-buybox__gbadge');
      var main = row.querySelector('.mm-buybox__gbadge-main');
      if (!badge || !main) return;
      var ar = parseFloat(badge.getAttribute('data-ar')) || 1;
      var cap = Math.min(150, row.clientWidth * 0.38);
      badge.style.width = Math.min(main.offsetHeight * ar, cap) + 'px';
    });
  };
  pass();
  pass();
}

function initGuaranteeBadges() {
  mmSizeGuaranteeBadges();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(mmSizeGuaranteeBadges);
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(mmSizeGuaranteeBadges, 120);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  // Critical path — wire interactions immediately
  initCountdown();
  initMiniReviews();
  initFaq();
  initStickyAtc();
  initStickyLabelDiscount();
  initWidgetLift();
  initStickyHeader();
  initNewsletter();
  initProductForms();
  initVariantPickers();
  initKachingVariantSync();
  initSubscriptionWidgets();
  initSubSheet();
  initAddonPeek();
  initEditorDrawerHooks();
  initGuaranteeBadges();

  // Reservation banner: prime data attrs so it renders correctly even
  // before the cart is opened. If the drawer is pinned open (theme
  // editor) or already open at boot, start ticking immediately.
  CartReserve.init();
  var __mmCartEl = document.getElementById('mm-cart');
  if (__mmCartEl && __mmCartEl.hasAttribute('data-open')) CartReserve.start();

  // Non-critical — fetch cart state during idle so it doesn't block LCP
  var fetchCart = function() { CartState.fetch(); };
  if ('requestIdleCallback' in window) {
    requestIdleCallback(fetchCart, { timeout: 2000 });
  } else {
    setTimeout(fetchCart, 800);
  }
});
